/* eslint-disable max-len */
import { defineMessages } from 'react-intl';
const messages = defineMessages({
    'account.activation.error': {
        id: 'account.activation.error',
        defaultMessage: 'This activation link is not valid.',
    },
    'account.activation.error.link.expired': {
        id: 'account.activation.error.link.expired',
        defaultMessage:
            'This activation link has expired. To resend it, <resendActivationPageLink>click here</resendActivationPageLink>.',
    },
    'account.activation.go.to.login.page': {
        id: 'account.activation.go.to.login.page',
        defaultMessage: 'Click here to Log In',
    },
    'account.activation.required': {
        id: 'account.activation.required',
        defaultMessage:
            'Your account requires activating. You should have received an email containing a link to activate this account. To resend it, <resendActivationPageLink>click here</resendActivationPageLink>.',
    },
    'account.activation.resent.intro': {
        id: 'account.activation.resent.intro',
        defaultMessage:
            "Enter the email address that you signed up with and we'll re-send you an activation link.",
    },
    'account.activation.resent.account.not.found': {
        id: 'account.activation.resent.account.not.found',
        defaultMessage: 'An account with this email address does not exist.',
    },
    'account.activation.resent.success': {
        id: 'account.activation.resent.success',
        defaultMessage: 'Activation link sent.',
    },
    'account.activation.resent.success.text': {
        id: 'account.activation.resent.success.text',
        defaultMessage:
            'We have re-sent you an email to activate this account. Check your inbox.',
    },
    'account.activation.resent.resend.button': {
        id: 'account.activation.resent.resend.button',
        defaultMessage: 'Re-send',
    },
    'account.activation.success': {
        id: 'account.activation.success',
        defaultMessage: 'Your account has been activated.',
    },
    'api.tokens.create.button': {
        id: 'api.tokens.create.button',
        defaultMessage: 'Create token',
    },
    'api.tokens.create.title': {
        id: 'api.tokens.create.title',
        defaultMessage: 'Create a new token',
    },
    'api.tokens.empty': {
        id: 'api.tokens.empty',
        defaultMessage: "You haven't created any tokens yet.",
    },
    'api.tokens.intro': {
        id: 'api.tokens.intro',
        defaultMessage:
            'Tokens let third-party applications add items to your tidee workspace on your behalf. Give each application its own token so you can revoke one without affecting the others.',
    },
    'api.tokens.list.title': {
        id: 'api.tokens.list.title',
        defaultMessage: 'Your tokens',
    },
    'api.tokens.name.label': {
        id: 'api.tokens.name.label',
        defaultMessage: 'What is this token for?',
    },
    'api.tokens.name.placeholder': {
        id: 'api.tokens.name.placeholder',
        defaultMessage: 'e.g. Claude Desktop',
    },
    'api.tokens.reveal.copy': {
        id: 'api.tokens.reveal.copy',
        defaultMessage: 'Copy',
    },
    'api.tokens.reveal.copied': {
        id: 'api.tokens.reveal.copied',
        defaultMessage: 'Copied',
    },
    'api.tokens.reveal.warning': {
        id: 'api.tokens.reveal.warning',
        defaultMessage:
            'Copy this token now. For your security it is not stored, so this is the only time it can be shown. If you lose it, revoke it and create another.',
    },
    'api.tokens.revoke': {
        id: 'api.tokens.revoke',
        defaultMessage: 'Revoke',
    },
    'api.tokens.revoke.cancel': {
        id: 'api.tokens.revoke.cancel',
        defaultMessage: 'Keep token',
    },
    'api.tokens.revoke.confirm': {
        id: 'api.tokens.revoke.confirm',
        defaultMessage: 'Revoke token',
    },
    'api.tokens.revoke.msg': {
        id: 'api.tokens.revoke.msg',
        defaultMessage:
            'Anything using this token will stop working immediately. This cannot be undone.',
    },
    'api.tokens.revoke.title': {
        id: 'api.tokens.revoke.title',
        defaultMessage: 'Revoke {name}?',
    },
    'api.tokens.scope.capture': {
        id: 'api.tokens.scope.capture',
        defaultMessage: 'Add new items',
    },
    'api.tokens.scope.items.read': {
        id: 'api.tokens.scope.items.read',
        defaultMessage: 'Read items',
    },
    'api.tokens.scope.items.write': {
        id: 'api.tokens.scope.items.write',
        defaultMessage: 'Edit and complete existing items',
    },
    'api.tokens.scopes.label': {
        id: 'api.tokens.scopes.label',
        defaultMessage: 'What should it be allowed to do?',
    },
    'api.tokens.title': {
        id: 'api.tokens.title',
        defaultMessage: 'API tokens',
    },
    'error.cannot.rename.workspace.root': {
        id: 'error.cannot.rename.workspace.root',
        defaultMessage: 'The Workspace cannot be renamed.',
    },
    'error.api.token.limit.reached': {
        id: 'error.api.token.limit.reached',
        defaultMessage:
            'You have reached the maximum number of tokens. Revoke one you no longer use before creating another.',
    },
    'error.api.token.name.required': {
        id: 'error.api.token.name.required',
        defaultMessage: 'Give the token a name so you can recognize it later.',
    },
    'error.api.token.name.too.long': {
        id: 'error.api.token.name.too.long',
        defaultMessage: 'That name is too long.',
    },
    'error.api.token.scope.unknown': {
        id: 'error.api.token.scope.unknown',
        defaultMessage: 'That permission is not recognized.',
    },
    'error.api.token.scopes.required': {
        id: 'error.api.token.scopes.required',
        defaultMessage: 'Choose at least one thing this token can do.',
    },
    'api.tokens.expiry.days': {
        id: 'api.tokens.expiry.days',
        defaultMessage: '{days} days',
    },
    'api.tokens.expiry.hint': {
        id: 'api.tokens.expiry.hint',
        defaultMessage:
            'A token that expires limits the damage if it ever leaks. We will email you {days} days before it does.',
    },
    'api.tokens.expiry.label': {
        id: 'api.tokens.expiry.label',
        defaultMessage: 'When should it expire?',
    },
    'api.tokens.expiry.never': {
        id: 'api.tokens.expiry.never',
        defaultMessage: 'Never',
    },
    'api.tokens.expiry.year': {
        id: 'api.tokens.expiry.year',
        defaultMessage: '1 year',
    },
    'error.api.token.expiry.unknown': {
        id: 'error.api.token.expiry.unknown',
        defaultMessage: 'That expiry option is not recognized.',
    },
    'api.tokens.field.access': {
        id: 'api.tokens.field.access',
        defaultMessage: 'Access',
    },
    'api.tokens.field.created': {
        id: 'api.tokens.field.created',
        defaultMessage: 'Created',
    },
    'api.tokens.field.expires': {
        id: 'api.tokens.field.expires',
        defaultMessage: 'Expires',
    },
    'api.tokens.field.last.used': {
        id: 'api.tokens.field.last.used',
        defaultMessage: 'Last used',
    },
    'api.tokens.field.name': {
        id: 'api.tokens.field.name',
        defaultMessage: 'Name',
    },
    'api.tokens.field.token': {
        id: 'api.tokens.field.token',
        defaultMessage: 'Token',
    },
    'api.tokens.value.never': {
        id: 'api.tokens.value.never',
        defaultMessage: 'Never',
    },
    'app.settings.modal.title': {
        id: 'app.settings.modal.title',
        defaultMessage: 'Application Settings',
    },
    'capture.modal.title': {
        id: 'capture.modal.title',
        defaultMessage: 'Add an item',
    },
    // Phase 2 slice F — captures-used indicator + paywall panel.
    'captures.used.count': {
        id: 'captures.used.count',
        defaultMessage: '{count} of {limit} captures used',
    },
    'captures.used.approaching': {
        id: 'captures.used.approaching',
        defaultMessage: "You're approaching your free plan limit",
    },
    'captures.used.at.limit': {
        id: 'captures.used.at.limit',
        defaultMessage: "You've used {limit} of {limit} free captures.",
    },
    'captures.used.upgrade.link': {
        id: 'captures.used.upgrade.link',
        defaultMessage: 'Upgrade to Standard plan',
    },
    'captures.used.learn': {
        id: 'captures.used.learn',
        defaultMessage: 'Learn about Standard',
    },
    'paywall.limit.modal.body': {
        id: 'paywall.limit.modal.body',
        defaultMessage:
            "You've used all your free captures. What you typed is still here — upgrade to save it, or close this and come back to it.",
    },
    // Shown when opening something in the workspace fails. The server's
    // own message is English and names internal ids — fine for the
    // console, not for a user — so the detail is logged and this is
    // what they read.
    'workspace.open.item.error': {
        id: 'workspace.open.item.error',
        defaultMessage:
            "We couldn't open that in the workspace. Please try again, and contact support if it keeps happening.",
    },
    'paywall.limit.modal.close': {
        id: 'paywall.limit.modal.close',
        defaultMessage: 'Close',
    },
    // Shown when the cap stops Quick Capture opening at all, so there is
    // no item and nothing to reassure the user about. The other two
    // strings — "that item wasn't saved", "what you typed is still
    // here" — are both untrue before anything has been written.
    'paywall.limit.modal.preopen.title': {
        id: 'paywall.limit.modal.preopen.title',
        defaultMessage: "You're out of free captures",
    },
    'paywall.limit.modal.preopen.body': {
        id: 'paywall.limit.modal.preopen.body',
        defaultMessage:
            "You've used all {limit} captures on the Free plan. Upgrade to keep adding items — everything you've already captured stays where it is.",
    },
    'paywall.limit.modal.title': {
        id: 'paywall.limit.modal.title',
        defaultMessage: "That item wasn't saved",
    },
    'paywall.title': {
        id: 'paywall.title',
        defaultMessage: "You've hit the Free plan cap",
    },
    'paywall.value.prop': {
        id: 'paywall.value.prop',
        defaultMessage: 'Standard gives you unlimited captures for $5 / month.',
    },
    'paywall.upgrade.button': {
        id: 'paywall.upgrade.button',
        defaultMessage: 'Upgrade to Standard',
    },
    // Phase 2 slice M — mailto footer for "over-and-above Standard"
    // users. Same copy on the paywall + Billing Custom tab.
    // Heading for the 'upsell' PaywallPanel variant — the Billing tab
    // renders the panel to every Free user regardless of captureCount,
    // so it must not claim they've hit the cap.
    'paywall.upsell.title': {
        id: 'paywall.upsell.title',
        defaultMessage: 'Upgrade to Standard',
    },
    'paywall.upgrade.coming.soon': {
        id: 'paywall.upgrade.coming.soon',
        defaultMessage:
            'Upgrades will be available soon — thanks for your patience.',
    },
    // Phase 2 slice H — Paddle checkout flow states.
    'paywall.checkout.loading': {
        id: 'paywall.checkout.loading',
        defaultMessage: 'Loading checkout…',
    },
    'paywall.checkout.processing': {
        id: 'paywall.checkout.processing',
        defaultMessage: 'Processing your upgrade…',
    },
    'paywall.checkout.processing.timeout': {
        id: 'paywall.checkout.processing.timeout',
        defaultMessage:
            'Still processing — check your email for confirmation, or refresh in a moment.',
    },
    'paywall.checkout.error': {
        id: 'paywall.checkout.error',
        defaultMessage: 'Could not open checkout. Please try again.',
    },
    // Phase 2 slice I — Billing settings tab.
    'settings.modal.app.nav.billing': {
        id: 'settings.modal.app.nav.billing',
        defaultMessage: 'Billing',
    },
    // One fixed section title for every tier — the body copy below it
    // is what varies, not the heading.
    'billing.title': {
        id: 'billing.title',
        defaultMessage: 'Your Plan',
    },
    'billing.free.captures.used': {
        id: 'billing.free.captures.used',
        defaultMessage: "You've used {count} of {limit} free captures.",
    },
    'billing.standard.price': {
        id: 'billing.standard.price',
        defaultMessage: '$5 per month, unlimited captures',
    },
    'billing.standard.next.renewal': {
        id: 'billing.standard.next.renewal',
        defaultMessage: 'Next renewal: {date}',
    },
    'billing.standard.cancelling.banner': {
        id: 'billing.standard.cancelling.banner',
        defaultMessage:
            'Your plan is set to cancel on {date}. Reactivate to keep unlimited captures.',
    },
    'billing.standard.past.due.banner': {
        id: 'billing.standard.past.due.banner',
        defaultMessage:
            'Your last payment failed. Retry it to keep your plan active.',
    },
    'billing.standard.paused.banner': {
        id: 'billing.standard.paused.banner',
        defaultMessage:
            'Your subscription is paused. Contact us to resume — your existing items stay accessible in the meantime.',
    },
    'billing.free.cancelled.on': {
        id: 'billing.free.cancelled.on',
        defaultMessage: 'Your Standard subscription was canceled on {date}.',
    },
    'billing.standard.button.contact': {
        id: 'billing.standard.button.contact',
        defaultMessage: 'Contact us',
    },
    'billing.standard.button.manage': {
        id: 'billing.standard.button.manage',
        defaultMessage: 'Manage subscription',
    },
    'billing.standard.button.cancel': {
        id: 'billing.standard.button.cancel',
        defaultMessage: 'Cancel',
    },
    'billing.standard.button.reactivate': {
        id: 'billing.standard.button.reactivate',
        defaultMessage: 'Reactivate',
    },
    'billing.standard.button.retry.payment': {
        id: 'billing.standard.button.retry.payment',
        defaultMessage: 'Retry payment',
    },
    'billing.portal.error': {
        id: 'billing.portal.error',
        defaultMessage:
            'Could not open the subscription portal. Please try again.',
    },
    'capture.workspace.empty.hint': {
        id: 'capture.workspace.empty.hint',
        defaultMessage:
            'Welcome — your <b>Workspace</b> box is where you add your top-level boxes and items. You can nest boxes within boxes - do whatever you need to organize your items in a way that makes sense to you.<br></br><br></br>Use <b>Add item</b> in the top bar to add items to your Workspace.',
    },
    'capture.workspace.empty.hint.mobile': {
        id: 'capture.workspace.empty.hint.mobile',
        defaultMessage:
            'Welcome — your <b>Workspace</b> box is where you add your top-level boxes and items. You can nest boxes within boxes - do whatever you need to organize your items in a way that makes sense to you.<br></br><br></br>Use the <b>Add</b> button in the navigation bar below to add items to your Workspace.',
    },
    'capture.modal.mode.prompt': {
        id: 'capture.modal.mode.prompt',
        defaultMessage: 'How would you like to add an item?',
    },
    'capture.modal.manual.prompt': {
        id: 'capture.modal.manual.prompt',
        defaultMessage: 'Complete the form below to add a new item.',
    },
    'notification.go.to.item': {
        id: 'notification.go.to.item',
        defaultMessage: 'Go to item',
    },
    'capture.modal.mode.manual': {
        id: 'capture.modal.mode.manual',
        defaultMessage: 'Type it',
    },
    'capture.modal.mode.manual.description': {
        id: 'capture.modal.mode.manual.description',
        defaultMessage: 'Fill in the details',
    },
    'capture.modal.mode.ai': {
        id: 'capture.modal.mode.ai',
        defaultMessage: 'Speak it',
    },
    'capture.modal.mode.ai.description': {
        id: 'capture.modal.mode.ai.description',
        defaultMessage: "Describe what you'd like to add",
    },
    'capture.ai.prompt': {
        id: 'capture.ai.prompt',
        defaultMessage:
            'Describe what you\'d like to add — you can describe multiple items in one sentence. e.g. "Create a Holiday box and add Sunscreen and Sunglasses to it". By default, items will be added to your Backlog unless you say to skip it (e.g. "add milk, skip backlog").',
    },
    'capture.ai.button.plan': {
        id: 'capture.ai.button.plan',
        defaultMessage: 'Plan',
    },
    'capture.ai.button.clear': {
        id: 'capture.ai.button.clear',
        defaultMessage: 'Clear',
    },
    'capture.ai.button.confirm': {
        id: 'capture.ai.button.confirm',
        defaultMessage: 'Create {count, plural, one {# item} other {# items}}',
    },
    'capture.ai.button.planning': {
        id: 'capture.ai.button.planning',
        defaultMessage: 'Planning…',
    },
    'capture.ai.button.creating': {
        id: 'capture.ai.button.creating',
        defaultMessage: 'Creating…',
    },
    'capture.ai.review.heading': {
        id: 'capture.ai.review.heading',
        defaultMessage: "Here's the plan:",
    },
    'capture.added.item': {
        id: 'capture.added.item',
        defaultMessage: 'Added: "{title}"',
    },
    'capture.added.box': {
        id: 'capture.added.box',
        defaultMessage: 'Created box: "{title}"',
    },
    'capture.added.error': {
        id: 'capture.added.error',
        defaultMessage: 'Failed to create item',
    },
    'capture.ai.review.action.box': {
        id: 'capture.ai.review.action.box',
        defaultMessage: 'Add box <b>"{title}"</b> to <b>{parent}</b>',
    },
    'capture.ai.review.action.item': {
        id: 'capture.ai.review.action.item',
        defaultMessage:
            'Add item <b>"{title}"</b> to <b>{parent}</b>{backlog, select, yes { — will be added to your Backlog} no { — will NOT be added to your Backlog} other {}}',
    },
    'capture.ai.review.parent.workspace': {
        id: 'capture.ai.review.parent.workspace',
        defaultMessage: 'Workspace',
    },
    'capture.ai.review.parent.new': {
        id: 'capture.ai.review.parent.new',
        defaultMessage: '(new) {title}',
    },
    'capture.ai.review.target.date': {
        id: 'capture.ai.review.target.date',
        defaultMessage: 'Target date: {date}',
    },
    'capture.ai.error.empty': {
        id: 'capture.ai.error.empty',
        defaultMessage: "Couldn't understand that — try rephrasing.",
    },
    'capture.ai.error.failed': {
        id: 'capture.ai.error.failed',
        defaultMessage: 'AI request failed. Try again.',
    },
    'capture.ai.error.create.failed': {
        id: 'capture.ai.error.create.failed',
        defaultMessage:
            'Failed to create "{title}". {created} of {total} done.',
    },
    'capture.ai.success': {
        id: 'capture.ai.success',
        defaultMessage: 'Created {count, plural, one {# item} other {# items}}',
    },
    'organizer.capture.verify': {
        id: 'organizer.capture.verify',
        defaultMessage: 'Captured hands-free — click if correct',
    },
    'tooltip.organizer.capture.verify': {
        id: 'tooltip.organizer.capture.verify',
        defaultMessage:
            'Click to confirm it is right — a dated item then moves to your Prioritized list.',
    },
    'capture.offline.saved': {
        id: 'capture.offline.saved',
        defaultMessage: 'Saved offline — will sync when online',
    },
    'capture.offline.badge.pending': {
        id: 'capture.offline.badge.pending',
        defaultMessage:
            '{count, plural, one {# capture pending sync} other {# captures pending sync}}',
    },
    'capture.offline.badge.failed': {
        id: 'capture.offline.badge.failed',
        defaultMessage:
            '{count, plural, one {# capture failed to sync} other {# captures failed to sync}}',
    },
    'capture.offline.panel.title': {
        id: 'capture.offline.panel.title',
        defaultMessage: 'Pending captures',
    },
    'capture.offline.panel.empty': {
        id: 'capture.offline.panel.empty',
        defaultMessage: 'No pending captures.',
    },
    'capture.offline.row.ai': {
        id: 'capture.offline.row.ai',
        defaultMessage: 'AI capture: "{transcript}"',
    },
    'capture.offline.row.manual': {
        id: 'capture.offline.row.manual',
        defaultMessage: 'Manual: "{title}"',
    },
    'capture.offline.row.status.failed': {
        id: 'capture.offline.row.status.failed',
        defaultMessage: 'Failed',
    },
    'capture.offline.row.status.pending': {
        id: 'capture.offline.row.status.pending',
        defaultMessage: 'Pending',
    },
    'capture.offline.action.retry': {
        id: 'capture.offline.action.retry',
        defaultMessage: 'Retry',
    },
    'capture.offline.action.dismiss': {
        id: 'capture.offline.action.dismiss',
        defaultMessage: 'Dismiss',
    },
    'capture.modal.voice.placeholder.listening': {
        id: 'capture.modal.voice.placeholder.listening',
        defaultMessage: 'Listening...',
    },
    'capture.modal.voice.button.stop': {
        id: 'capture.modal.voice.button.stop',
        defaultMessage: 'Stop listening',
    },
    'capture.modal.voice.button.start': {
        id: 'capture.modal.voice.button.start',
        defaultMessage: 'Click to speak',
    },
    'capture.modal.field.title': {
        id: 'capture.modal.field.title',
        defaultMessage: 'Title',
    },
    'rich.text.toolbar.italic': {
        id: 'rich.text.toolbar.italic',
        defaultMessage: 'Italic',
    },
    'rich.text.toolbar.link': {
        id: 'rich.text.toolbar.link',
        defaultMessage: 'Link',
    },
    'rich.text.link.placeholder': {
        id: 'rich.text.link.placeholder',
        defaultMessage: 'Paste or type a link',
    },
    'rich.text.link.text.label': {
        id: 'rich.text.link.text.label',
        defaultMessage: 'Text',
    },
    'rich.text.link.url.label': {
        id: 'rich.text.link.url.label',
        defaultMessage: 'Link',
    },
    'rich.text.link.title.edit': {
        id: 'rich.text.link.title.edit',
        defaultMessage: 'Edit link',
    },
    'rich.text.link.title': {
        id: 'rich.text.link.title',
        defaultMessage: 'Add a link',
    },
    'rich.text.link.apply': {
        id: 'rich.text.link.apply',
        defaultMessage: 'Apply',
    },
    'rich.text.link.remove': {
        id: 'rich.text.link.remove',
        defaultMessage: 'Remove',
    },
    'rich.text.toolbar.bold': {
        id: 'rich.text.toolbar.bold',
        defaultMessage: 'Bold',
    },
    'rich.text.toolbar.underline': {
        id: 'rich.text.toolbar.underline',
        defaultMessage: 'Underline',
    },
    'capture.modal.field.type': {
        id: 'capture.modal.field.type',
        defaultMessage: 'Type',
    },
    'capture.modal.field.type.hint': {
        id: 'capture.modal.field.type.hint',
        defaultMessage: 'Note: A Box can contain other items.',
    },
    'capture.modal.field.parent.box': {
        id: 'capture.modal.field.parent.box',
        defaultMessage: 'Parent box',
    },
    'capture.modal.field.parent.box.hint.fixed': {
        id: 'capture.modal.field.parent.box.hint.fixed',
        defaultMessage:
            "Fixed to the box you're inserting into, so the item lands where you clicked.",
    },
    'capture.modal.field.parent.box.hint': {
        id: 'capture.modal.field.parent.box.hint',
        defaultMessage: 'Your newly added item will end up in this box.',
    },
    'capture.modal.field.target.date': {
        id: 'capture.modal.field.target.date',
        defaultMessage: 'Target date',
    },
    'capture.modal.field.target.date.hint': {
        id: 'capture.modal.field.target.date.hint',
        defaultMessage:
            'When this item should show up in your Today list. Leave empty to keep it date-free.',
    },
    'capture.modal.field.target.date.none': {
        id: 'capture.modal.field.target.date.none',
        defaultMessage: 'No target date',
    },
    'capture.modal.field.target.date.clear': {
        id: 'capture.modal.field.target.date.clear',
        defaultMessage: 'Clear',
    },
    'capture.modal.field.add.to.backlog.hint': {
        id: 'capture.modal.field.add.to.backlog.hint',
        defaultMessage:
            'The Backlog is a dumping ground for items that need prioritizing.',
    },
    'capture.modal.field.add.to.backlog': {
        id: 'capture.modal.field.add.to.backlog',
        defaultMessage: 'Add to Backlog?',
    },
    'capture.modal.field.add.to.backlog.dated.hint': {
        id: 'capture.modal.field.add.to.backlog.dated.hint',
        defaultMessage: 'Dated items go straight to your Prioritized list.',
    },
    'capture.modal.button.back': {
        id: 'capture.modal.button.back',
        defaultMessage: 'Back',
    },
    'capture.modal.button.add.item': {
        id: 'capture.modal.button.add.item',
        defaultMessage: 'Add Item',
    },
    'capture.modal.button.parsing': {
        id: 'capture.modal.button.parsing',
        defaultMessage: 'Parsing...',
    },
    'capture.modal.button.review': {
        id: 'capture.modal.button.review',
        defaultMessage: 'Review...',
    },
    'capture.modal.parent.box.workspace': {
        id: 'capture.modal.parent.box.workspace',
        defaultMessage: 'Workspace',
    },
    'box.create.modal.no.title': {
        id: 'box.create.modal.no.title',
        defaultMessage: 'Enter a Box title.',
    },
    'box.create.modal.save.failure': {
        id: 'box.create.modal.save.failure',
        defaultMessage:
            'A technical issue occurred while trying to save your Box.',
    },
    'box.create.modal.new.box': {
        id: 'box.create.modal.new.box',
        defaultMessage: 'Create a new box',
    },
    'box.create.modal.create.box': {
        id: 'box.create.modal.create.box',
        defaultMessage: 'Create Box',
    },
    'box.create.modal.what.title': {
        id: 'box.create.modal.what.title',
        defaultMessage: 'What do you want the title of your new Box to be?',
    },
    'box.create.modal.title.placeholder': {
        id: 'box.create.modal.title.placeholder',
        defaultMessage: 'Title of your new box',
    },
    'box.create.modal.or': {
        id: 'box.create.modal.or',
        defaultMessage: 'or',
    },
    'box.create.modal.cancel': {
        id: 'box.create.modal.cancel',
        defaultMessage: 'cancel',
    },
    'box.finder.item.button.move': {
        id: 'box.finder.item.button.move',
        defaultMessage: 'Move',
    },
    'box.finder.item.button.open': {
        id: 'box.finder.item.button.open',
        defaultMessage: 'Open',
    },
    'box.finder.item.button.select': {
        id: 'box.finder.item.button.select',
        defaultMessage: 'Select',
    },
    'box.finder.search.placeholder': {
        id: 'box.finder.search.placeholder',
        defaultMessage: 'Search all boxes',
    },
    'box.finder.search.no.results': {
        id: 'box.finder.search.no.results',
        defaultMessage: 'No boxes match your search.',
    },
    'box.finder.loading.msg': {
        id: 'box.finder.loading.msg',
        defaultMessage: 'Loading boxes...',
    },
    'box.finder.no.items': {
        id: 'box.finder.no.items',
        defaultMessage: 'This box is empty',
    },
    'box.settings.modal.archive.box': {
        id: 'box.settings.modal.archive.box',
        defaultMessage: 'Archive Box',
    },
    'box.settings.modal.archived.msg': {
        id: 'box.settings.modal.archived.msg',
        defaultMessage: 'This box was archived on {archivedDate}.',
    },
    'box.settings.modal.item.options': {
        id: 'box.settings.modal.item.options',
        defaultMessage: 'Options',
    },
    'box.settings.modal.no.title': {
        id: 'box.settings.modal.no.title',
        defaultMessage: '(no title)',
    },
    'box.settings.modal.title': {
        id: 'box.settings.modal.title',
        defaultMessage: 'Title',
    },
    'box.settings.open.this.box': {
        id: 'box.settings.open.this.box',
        defaultMessage: 'Open this box',
    },
    'boxes.get.failure': {
        id: 'boxes.get.failure',
        defaultMessage: 'Your Boxes could not be retrieved.',
    },
    'common.click': {
        id: 'common.click',
        defaultMessage: 'Click',
    },
    'common.here': {
        id: 'common.here',
        defaultMessage: 'here',
    },
    'drop.guide.msg': {
        id: 'drop.guide.msg',
        defaultMessage: 'Drop the item here to add it to this list.',
    },
    'error.404.title': {
        id: 'error.404.title',
        defaultMessage: 'Error 404',
    },
    'error.404.msg': {
        id: 'error.404.msg',
        defaultMessage:
            "Oops, we couldn't find the page that you were looking for.",
    },
    'error.500.msg': {
        id: 'error.500.msg',
        defaultMessage:
            'An unexpected error occurred. Please try again in a few moments.',
    },
    'error.boundary.intro': {
        id: 'error.boundary.intro',
        defaultMessage:
            'It looks like something went wrong with this application. We have been made aware of the problem and are looking into it. Please try again later.',
    },
    'error.boundary.title': {
        id: 'error.boundary.title',
        defaultMessage: 'Oops, something went wrong :(',
    },
    // The title on every mobile error Alert — 40-odd call sites across
    // 15 screens referenced this id before it was ever declared, and the
    // mobile IntlProvider sets `onError: () => {}`, so react-intl's
    // missing-translation warning was swallowed and every one of those
    // alerts rendered the literal string 'error.generic.title'.
    'error.generic.title': {
        id: 'error.generic.title',
        defaultMessage: 'Something went wrong',
    },
    'error.modal.item.save.error': {
        id: 'error.modal.item.save.error',
        defaultMessage: 'Item save error',
    },
    'error.share.generic': {
        id: 'error.share.generic',
        defaultMessage: "That couldn't be shared. Please try again.",
    },
    // Deliberately vague. One of the reasons a share is refused is that
    // the recipient has blocked the sender, and confirming that to the
    // sender is itself a way to harass.
    'error.share.not.permitted': {
        id: 'error.share.not.permitted',
        defaultMessage: 'You are unable to share with this person.',
    },
    'error.no.rights.to.share.item': {
        id: 'error.no.rights.to.share.item',
        defaultMessage: 'You do not have rights to share this item.',
    },
    'error.cannot.remove.co.owner.share': {
        id: 'error.cannot.remove.co.owner.share',
        defaultMessage:
            "You can't remove another owner directly. Change their role to editor or viewer first, then remove them.",
    },
    'error.cannot.leave.as.last.owner': {
        id: 'error.cannot.leave.as.last.owner',
        defaultMessage:
            "You can't leave an item as its last owner. Promote another user to owner first.",
    },
    'favourites.label': {
        id: 'favourites.label',
        defaultMessage: 'Favorites',
    },
    'forgot.form.intro': {
        id: 'forgot.form.intro',
        defaultMessage:
            'Enter your registered email address into the box below.',
    },
    'forgot.error.account.not.found': {
        id: 'forgot.error.account.not.found',
        defaultMessage:
            'An account with this email address could not be found.',
    },
    'forgot.success.title': {
        id: 'forgot.success.title',
        defaultMessage: 'Check your email',
    },
    'forgot.success': {
        id: 'forgot.success',
        defaultMessage:
            'Details on how to reset your password have been sent to your email address.',
    },
    'generic.button.cancel': {
        id: 'generic.button.cancel',
        defaultMessage: 'Cancel',
    },
    'generic.button.delete': {
        id: 'generic.button.delete',
        defaultMessage: 'Delete',
    },
    'generic.button.invite': {
        id: 'generic.button.invite',
        defaultMessage: 'Send Invite',
    },
    'generic.button.okay': {
        id: 'generic.button.okay',
        defaultMessage: 'Okay',
    },
    'generic.button.save': {
        id: 'generic.button.save',
        defaultMessage: 'Save',
    },
    'generic.field.label.email': {
        id: 'generic.field.label.email',
        defaultMessage: 'Email',
    },
    'generic.field.label.language': {
        id: 'generic.field.label.language',
        defaultMessage: 'Language',
    },
    'generic.field.label.name': {
        id: 'generic.field.label.name',
        defaultMessage: 'Name',
    },
    'generic.field.label.organisation': {
        id: 'generic.field.label.organisation',
        defaultMessage: 'Organization',
    },
    'generic.field.label.ownership': {
        id: 'generic.field.label.ownership',
        defaultMessage: 'Ownership',
    },
    'generic.field.label.password': {
        id: 'generic.field.label.password',
        defaultMessage: 'Password',
    },
    'generic.field.validation.email.already.in.use.msg': {
        id: 'generic.field.validation.email.already.in.use.msg',
        defaultMessage: 'This email address is already in use.',
    },
    'generic.field.validation.email.invalid.msg': {
        id: 'generic.field.validation.email.invalid.msg',
        defaultMessage: 'Enter a valid email address.',
    },
    'generic.field.validation.name.empty.msg': {
        id: 'generic.field.validation.name.empty.msg',
        defaultMessage: 'Enter your name.',
    },
    'generic.field.validation.organisation.empty.msg': {
        id: 'generic.field.validation.organisation.empty.msg',
        defaultMessage: 'Enter an organization name.',
    },
    'generic.field.validation.password.invalid.msg': {
        id: 'generic.field.validation.password.invalid.msg',
        defaultMessage:
            'Your password must be at least 8 characters in length.',
    },
    'generic.field.validation.timezone.unselected.msg': {
        id: 'generic.field.validation.timezone.unselected.msg',
        defaultMessage: 'Select a timezone.',
    },
    'generic.link.back': {
        id: 'generic.link.back',
        defaultMessage: '< Back',
    },
    'generic.problem.occurred.msg': {
        id: 'generic.problem.occurred.msg',
        defaultMessage: 'A problem occurred trying to perform this action.',
    },
    'header.button.application.settings.tooltip': {
        id: 'header.button.application.settings.tooltip',
        defaultMessage: 'Application Settings',
    },
    'header.button.support.tooltip': {
        id: 'header.button.support.tooltip',
        defaultMessage: 'Help & Support',
    },
    'header.button.logout.tooltip': {
        id: 'header.button.logout.tooltip',
        defaultMessage: 'Logout',
    },
    'header.button.organisations.tooltip': {
        id: 'header.button.organisations.tooltip',
        defaultMessage: 'Organizations',
    },
    'header.button.organiser.tooltip': {
        id: 'header.button.organiser.tooltip',
        defaultMessage: 'Organizer',
    },
    'header.button.reminders.tooltip': {
        id: 'header.button.reminders.tooltip',
        defaultMessage: 'Reminders',
    },
    'sidebar.button.toggle.pane.widths': {
        id: 'sidebar.button.toggle.pane.widths',
        defaultMessage: 'Toggle pane widths',
    },
    'header.button.search.label': {
        id: 'header.button.search.label',
        defaultMessage: 'Search',
    },
    'header.button.add.item.label': {
        id: 'header.button.add.item.label',
        defaultMessage: 'Add item',
    },
    'header.button.workspace.tooltip': {
        id: 'header.button.workspace.tooltip',
        defaultMessage: 'Workspace',
    },
    'item.already.exists.in.parent.box': {
        id: 'item.already.exists.in.parent.box',
        defaultMessage: 'This item already exists in the parent box.',
    },
    'item.menu.set.target.date': {
        id: 'item.menu.set.target.date',
        defaultMessage: 'Set target date',
    },
    'item.ownership.capability.1': {
        id: 'item.ownership.capability.1',
        defaultMessage: 'Update the target date of an item.',
    },
    'item.ownership.capability.2': {
        id: 'item.ownership.capability.2',
        defaultMessage: 'Generally be able to make updates to an item.',
    },
    'item.ownership.capability.3': {
        id: 'item.ownership.capability.3',
        defaultMessage: 'Archive an item.',
    },
    'item.ownership.capability.4': {
        id: 'item.ownership.capability.4',
        defaultMessage: 'Edit the user ownership of an item.',
    },
    'item.ownership.capability.5': {
        id: 'item.ownership.capability.5',
        defaultMessage: 'Remove a users ownership of an item.',
    },
    'item.ownership.capability.6': {
        id: 'item.ownership.capability.6',
        defaultMessage: 'View the details of an item.',
    },
    'item.ownership.capability.7': {
        id: 'item.ownership.capability.7',
        defaultMessage: 'Transfer ownership of the item to another user.',
    },
    'item.ownership.capability.8': {
        id: 'item.ownership.capability.8',
        defaultMessage:
            'Step down as an Owner (when another Owner still holds the item).',
    },
    'item.ownership.capability.category.1': {
        id: 'item.ownership.capability.category.1',
        defaultMessage: 'Specific Todo Item Details.',
    },
    'item.ownership.capability.category.2': {
        id: 'item.ownership.capability.category.2',
        defaultMessage: 'Editing of entire Todo Item (mongoose model level).',
    },
    'item.ownership.editor.text': {
        id: 'item.ownership.editor.text',
        defaultMessage: 'Editor',
    },
    'item.ownership.owner.text': {
        id: 'item.ownership.owner.text',
        defaultMessage: 'Owner',
    },
    'item.ownership.readonly.text': {
        id: 'item.ownership.readonly.text',
        defaultMessage: 'Readonly',
    },
    'item.settings.modal.app.nav.common': {
        id: 'item.settings.modal.app.nav.common',
        defaultMessage: 'Common',
    },
    'item.settings.modal.app.nav.move': {
        id: 'item.settings.modal.app.nav.move',
        defaultMessage: 'Move',
    },
    'item.settings.modal.app.nav.share': {
        id: 'item.settings.modal.app.nav.share',
        defaultMessage: 'Share',
    },
    'item.settings.modal.archive.item': {
        id: 'item.settings.modal.archive.item',
        defaultMessage: 'Archive Item',
    },
    'item.settings.modal.archive.text': {
        id: 'item.settings.modal.archive.text',
        defaultMessage:
            'To archive this item immediately, click the button below.',
    },
    'item.settings.modal.auto.archive.expiry.duration.day': {
        id: 'item.settings.modal.auto.archive.expiry.duration.day',
        defaultMessage: 'day',
    },
    'item.settings.modal.auto.archive.expiry.duration.days': {
        id: 'item.settings.modal.auto.archive.expiry.duration.days',
        defaultMessage: 'days',
    },
    'item.settings.modal.auto.archive.expiry.duration.month': {
        id: 'item.settings.modal.auto.archive.expiry.duration.month',
        defaultMessage: 'month',
    },
    'item.settings.modal.auto.archive.expiry.duration.months': {
        id: 'item.settings.modal.auto.archive.expiry.duration.months',
        defaultMessage: 'months',
    },
    'item.settings.modal.auto.archive.expiry.duration.none': {
        id: 'item.settings.modal.auto.archive.expiry.duration.none',
        defaultMessage: 'None',
    },
    'item.settings.modal.auto.archive.expiry.duration.week': {
        id: 'item.settings.modal.auto.archive.expiry.duration.week',
        defaultMessage: 'week',
    },
    'item.settings.modal.auto.archive.expiry.duration.weeks': {
        id: 'item.settings.modal.auto.archive.expiry.duration.weeks',
        defaultMessage: 'weeks',
    },
    'item.settings.modal.auto.archive.expiry.duration.year': {
        id: 'item.settings.modal.auto.archive.expiry.duration.year',
        defaultMessage: 'year',
    },
    'item.settings.modal.auto.archive.expiry.duration.years': {
        id: 'item.settings.modal.auto.archive.expiry.duration.years',
        defaultMessage: 'years',
    },
    'item.settings.modal.auto.archive.expiry.text': {
        id: 'item.settings.modal.auto.archive.expiry.text',
        defaultMessage: 'This item will be automatically archived at',
    },
    'item.settings.modal.auto.archive.item': {
        id: 'item.settings.modal.auto.archive.item',
        defaultMessage: 'Auto-archive Item',
    },
    'item.settings.modal.auto.archive.text': {
        id: 'item.settings.modal.auto.archive.text',
        defaultMessage:
            'To auto-archive this item in the future, select the amount of time after which this item will be automatically archived.',
    },
    'item.settings.modal.open.parent.box': {
        id: 'item.settings.modal.open.parent.box',
        defaultMessage: 'Open parent box',
    },
    'item.settings.modal.title': {
        id: 'item.settings.modal.title',
        defaultMessage: 'Item Settings',
    },
    'login.email.field.label': {
        id: 'login.email.field.label',
        defaultMessage: 'Email',
    },
    'login.error.account.credentials': {
        id: 'login.error.account.credentials',
        defaultMessage: 'We could not find an account with these credentials.',
    },
    'login.forgot.btn.label': {
        id: 'login.forgot.btn.label',
        defaultMessage: 'Send Reminder Email',
    },
    // The toggle is an eye icon, so these are its accessible name and
    // its tooltip rather than visible button text — an unlabelled icon
    // button is announced as just "button", and an eye glyph does not
    // say which direction it acts in.
    'auth.password.show.a11y': {
        id: 'auth.password.show.a11y',
        defaultMessage: 'Show password',
    },
    'auth.password.hide.a11y': {
        id: 'auth.password.hide.a11y',
        defaultMessage: 'Hide password',
    },
    'login.forgot.msg': {
        id: 'login.forgot.msg',
        defaultMessage: 'Forgotten password?',
    },
    'login.login.btn.label': {
        id: 'login.login.btn.label',
        defaultMessage: 'Log In',
    },
    'login.login.msg': {
        id: 'login.login.msg',
        defaultMessage: 'Log In',
    },
    'login.remember.msg': {
        id: 'login.remember.msg',
        defaultMessage: 'Remember me',
    },
    'login.pass.reset.btn.label': {
        id: 'login.pass.reset.btn.label',
        defaultMessage: 'Confirm',
    },
    'login.password.field.label': {
        id: 'login.password.field.label',
        defaultMessage: 'Password',
    },
    'login.signup.dont.have.account.msg': {
        id: 'login.signup.dont.have.account.msg',
        defaultMessage: "Don't have an account?",
    },
    'login.signup.msg': {
        id: 'login.signup.msg',
        defaultMessage: 'Sign Up',
    },
    'no.pane.items.add.btn': {
        id: 'no.pane.items.add.btn',
        defaultMessage: 'Add an item',
    },
    'no.pane.items.completed.items': {
        id: 'no.pane.items.completed.items',
        defaultMessage: 'completed items',
    },
    'no.pane.items.like.to.add': {
        id: 'no.pane.items.like.to.add',
        defaultMessage:
            'This box is empty. Use <b>Add item</b> in the top bar to add items.',
    },
    'no.pane.items.hidden.by.space': {
        id: 'no.pane.items.hidden.by.space',
        defaultMessage:
            '{count, plural, one {# item is hidden} other {# items are hidden}} by your Spaces filter. Toggle the Space back on in the sidebar to see them.',
    },
    'no.panes.intro': {
        id: 'no.panes.intro',
        defaultMessage:
            'You do not have any panes open in your Workspace. Select one of the items below to open it.',
    },
    'no.panes.select.box.error': {
        id: 'no.panes.select.box.error',
        defaultMessage: 'Select a Box to open.',
    },
    'no.search.results.none.found': {
        id: 'no.search.results.none.found',
        defaultMessage: 'No results found',
    },
    'organisation.capabilities.intro': {
        id: 'organisation.capabilities.intro',
        defaultMessage: 'Capabilities of this ownership level:',
    },
    'organisation.invite.already.accepted': {
        id: 'organisation.invite.already.accepted',
        defaultMessage:
            'The invitation to join this organization has already been accepted.',
    },
    'organisation.invite.error.expired.link': {
        id: 'organisation.invite.error.expired.link',
        defaultMessage: 'The invitation to join this organization has expired.',
    },
    'organisation.invite.error.invalid.link': {
        id: 'organisation.invite.error.invalid.link',
        defaultMessage: 'The invitation to join this organization is invalid.',
    },
    'organisation.invite.member.already.exists': {
        id: 'organisation.invite.member.already.exists',
        defaultMessage: 'The invitee is already a member of this organization.',
    },
    'organisation.ownership.administrator.text': {
        id: 'organisation.ownership.administrator.text',
        defaultMessage: 'Administrator',
    },
    'organisation.ownership.member.text': {
        id: 'organisation.ownership.member.text',
        defaultMessage: 'Member',
    },
    'organisations.modal.member.edit.intro': {
        id: 'organisations.modal.member.edit.intro',
        defaultMessage: 'Update details of this member below.',
    },
    'organisations.modal.member.edit.cancel.button': {
        id: 'organisations.modal.member.edit.cancel.button',
        defaultMessage: 'Cancel',
    },
    'organisations.modal.member.edit.save.button': {
        id: 'organisations.modal.member.edit.save.button',
        defaultMessage: 'Save',
    },
    'organisations.modal.member.edit.title': {
        id: 'organisations.modal.member.edit.title',
        defaultMessage: 'Edit Member',
    },
    'organisations.modal.members.manage.button': {
        id: 'organisations.modal.members.manage.button',
        defaultMessage: 'Manage',
    },
    'organisations.modal.nav.details': {
        id: 'organisations.modal.nav.details',
        defaultMessage: 'Details',
    },
    'organisations.modal.nav.members': {
        id: 'organisations.modal.nav.members',
        defaultMessage: 'Members',
    },
    'organisations.modal.organisation.ownership.capability.1': {
        id: 'organisations.modal.organisation.ownership.capability.1',
        defaultMessage: 'Able to update the details of an Organization.',
    },
    'organisations.modal.organisation.ownership.capability.2': {
        id: 'organisations.modal.organisation.ownership.capability.2',
        defaultMessage: 'Able to invite new members to an Organization.',
    },
    'organisations.modal.organisation.ownership.capability.4': {
        id: 'organisations.modal.organisation.ownership.capability.4',
        defaultMessage: 'Able to update existing members of an Organization.',
    },
    'organisations.modal.organisation.ownership.capability.5': {
        id: 'organisations.modal.organisation.ownership.capability.5',
        defaultMessage:
            'Able to delete an Organization that they are a member of.',
    },
    'organisations.modal.organisation.ownership.capability.6': {
        id: 'organisations.modal.organisation.ownership.capability.6',
        defaultMessage:
            'Able to transfer ownership of items in the organization to another member.',
    },
    'organisations.modal.organisation.ownership.capabilities': {
        id: 'organisations.modal.organisation.ownership.capabilities',
        defaultMessage: '{ownershipName} capabilities...',
    },
    'organisations.modal.organisation.primary': {
        id: 'organisations.modal.organisation.primary',
        defaultMessage: '(primary)',
    },
    'organisations.modal.organisations.accept.invite.button': {
        id: 'organisations.modal.organisations.accept.invite.button',
        defaultMessage: 'Accept Invite',
    },
    'organisations.modal.organisations.create.button': {
        id: 'organisations.modal.organisations.create.button',
        defaultMessage: 'Create',
    },
    'organisations.modal.organisations.intro': {
        id: 'organisations.modal.organisations.intro',
        defaultMessage: 'You belong to the following organization(s).',
    },
    'organisations.modal.organisations.invite.button': {
        id: 'organisations.modal.organisations.invite.button',
        defaultMessage: 'Invite',
    },
    'organisations.modal.organisations.manage.button': {
        id: 'organisations.modal.organisations.manage.button',
        defaultMessage: 'Manage',
    },
    'organisations.modal.selected.organisation.invite.email': {
        id: 'organisations.modal.selected.organisation.invite.email',
        defaultMessage: 'Email address',
    },
    'organisations.modal.selected.organisation.invite.msg': {
        id: 'organisations.modal.selected.organisation.invite.msg',
        defaultMessage:
            'To invite someone into this organization, enter their email address below. This person will be able to share items with members of the selected organization.',
    },
    'organisations.modal.selected.organisation.invited': {
        id: 'organisations.modal.selected.organisation.invited',
        defaultMessage: 'The invitation email has been sent.',
    },
    'organisations.modal.selected.organisation.name': {
        id: 'organisations.modal.selected.organisation.name',
        defaultMessage: 'Organization name',
    },
    'organisations.modal.selected.organisation.ownership.types': {
        id: 'organisations.modal.selected.organisation.ownership.types',
        defaultMessage: 'Ownership Types',
    },
    'organisations.modal.selected.organisation.updated': {
        id: 'organisations.modal.selected.organisation.updated',
        defaultMessage: 'Organization details have been updated.',
    },
    'organisations.modal.title': {
        id: 'organisations.modal.title',
        defaultMessage: 'Organization(s)',
    },
    'organisations.modal.title.members': {
        id: 'organisations.modal.title.members',
        defaultMessage: 'Members',
    },
    'organisations.modal.title.members.intro': {
        id: 'organisations.modal.title.members.intro',
        defaultMessage:
            'Below is a list of members of the selected Organization.',
    },
    'organisations.modal.title.members.select.organisation': {
        id: 'organisations.modal.title.members.select.organisation',
        defaultMessage: 'Select an Organization from the list below.',
    },
    'organisations.modal.title.create.organisation': {
        id: 'organisations.modal.title.create.organisation',
        defaultMessage: 'Create a new Organization',
    },
    'organisations.modal.create.organisation.intro': {
        id: 'organisations.modal.create.organisation.intro',
        defaultMessage:
            'Click the button below to create a new organization and invite people into your organization.',
    },
    'organisations.modal.create.organisation.text': {
        id: 'organisations.modal.create.organisation.text',
        defaultMessage: 'Complete the form below to create a new organization.',
    },
    'organisations.modal.title.organisations': {
        id: 'organisations.modal.title.organisations',
        defaultMessage: 'Your Organizations',
    },
    'organisations.modal.title.your.invites': {
        id: 'organisations.modal.title.your.invites',
        defaultMessage: 'Your Invites',
    },
    'organisations.modal.title.your.invites.empty': {
        id: 'organisations.modal.title.your.invites.empty',
        defaultMessage: 'You do not have any invites to other organizations.',
    },
    'organisations.modal.title.your.invites.intro': {
        id: 'organisations.modal.title.your.invites.intro',
        defaultMessage: 'Below are your invitations into other organizations.',
    },
    'organisations.modal.organisations.delete.title': {
        id: 'organisations.modal.organisations.delete.title',
        defaultMessage: 'Delete Organization',
    },
    'organisations.modal.organisations.delete.incorrect.org.name': {
        id: 'organisations.modal.organisations.delete.incorrect.org.name',
        defaultMessage: 'You did not supply the correct organization name.',
    },
    'organisations.modal.organisations.delete.intro': {
        id: 'organisations.modal.organisations.delete.intro',
        defaultMessage:
            'If you want to permanently delete this organization, enter the name of the organization below and click "Delete".',
    },
    'organisations.modal.title.organisations.invite': {
        id: 'organisations.modal.title.organisations.invite',
        defaultMessage: 'Invite Others to {organisationName}',
    },
    'organisations.modal.title.organisations.selected': {
        id: 'organisations.modal.title.organisations.selected',
        defaultMessage: 'Selected Organization ({organisationName})',
    },
    'organizer.items.set.date': {
        id: 'organizer.items.set.date',
        defaultMessage: 'Set',
    },
    'organizer.items.set.target.date.tooltip': {
        id: 'organizer.items.set.target.date.tooltip',
        defaultMessage: 'Set Target Date',
    },
    'pane.box.title.change.failure': {
        id: 'pane.box.title.change.failure',
        defaultMessage: 'Changes to the box title could not be saved.',
    },
    'pane.create.item.error': {
        id: 'pane.create.item.error',
        defaultMessage: 'The item you selected could not be added.',
    },
    'pane.item.box.save.failure': {
        id: 'pane.item.box.save.failure',
        defaultMessage: 'Box details could not be saved.',
    },
    'pane.item.box.save.failure.reserved.name': {
        id: 'pane.item.box.save.failure.reserved.name',
        defaultMessage:
            'You cannot create an item with this name as this name is reserved.',
    },
    'pane.item.text.save.failure': {
        id: 'pane.item.text.save.failure',
        defaultMessage: 'Text details could not be saved.',
    },
    'pane.items.fetch.error': {
        id: 'pane.items.fetch.error',
        defaultMessage: 'The items for this Box could not be retrieved.',
    },
    'pane.remove.box.failure': {
        id: 'pane.remove.box.failure',
        defaultMessage: 'This box could not be removed from your workspace.',
    },
    'pane.workspace.no.pane.items': {
        id: 'pane.workspace.no.pane.items',
        defaultMessage: 'Your workspace does not contain any items.',
    },
    'pane.workspace.no.pane.items.box.btn': {
        id: 'pane.workspace.no.pane.items.box.btn',
        defaultMessage: 'Add a new Box',
    },
    'pane.workspace.search.close.failure': {
        id: 'pane.workspace.search.close.failure',
        defaultMessage: 'This search pane could not be closed.',
    },
    'pane.workspace.search.edit.workspace': {
        id: 'pane.workspace.search.edit.workspace',
        defaultMessage: 'Edit your Workspace',
    },
    'pane.workspace.search.go.to.workspace': {
        id: 'pane.workspace.search.go.to.workspace',
        defaultMessage: 'Go to Workspace',
    },
    'pane.workspace.search.include.archived': {
        id: 'pane.workspace.search.include.archived',
        defaultMessage: 'Archived',
    },
    'pane.workspace.search.include.completed': {
        id: 'pane.workspace.search.include.completed',
        defaultMessage: 'Completed',
    },
    'pane.workspace.search.no.favourites': {
        id: 'pane.workspace.search.no.favourites',
        defaultMessage: 'You do not have any Favorited items.',
    },
    'pane.workspace.search.no.workspace.items': {
        id: 'pane.workspace.search.no.workspace.items',
        defaultMessage: 'You do not have any items in your Workspace.',
    },
    'password.reset.error.invalid.link': {
        id: 'password.reset.error.invalid.link',
        defaultMessage: 'This password reset link is not valid.',
    },
    'password.reset.page.intro': {
        id: 'password.reset.page.intro',
        defaultMessage: 'Enter your new password into the box below.',
    },
    'password.reset.success': {
        id: 'password.reset.success',
        defaultMessage: 'Your password has been reset.',
    },
    'password.reset.success.login.text': {
        id: 'password.reset.success.login.text',
        defaultMessage: 'You can now login with your details.',
    },
    'prioritized.items.save.failure': {
        id: 'prioritized.items.save.failure',
        defaultMessage: 'Text details could not be saved.',
    },
    'prioritized.list.day.marker.today': {
        id: 'prioritized.list.day.marker.today',
        defaultMessage: 'Today',
    },
    'prioritized.list.day.marker.undated': {
        id: 'prioritized.list.day.marker.undated',
        defaultMessage: 'Undated',
    },
    'prioritized.list.heading': {
        id: 'prioritized.list.heading',
        defaultMessage: 'Prioritized list',
    },
    'prioritized.list.item.heading': {
        id: 'prioritized.list.item.heading',
        defaultMessage: 'Item',
    },
    'prioritized.list.items': {
        id: 'prioritized.list.items',
        defaultMessage: 'items',
    },
    'prioritized.list.no.items': {
        id: 'prioritized.list.no.items',
        defaultMessage:
            "Nothing prioritized yet. This page will show your items in priority order. An items' priority is determined by its <b>target date</b>, or if it is <b>pinned</b>.",
    },
    'prioritized.list.no.today.items': {
        id: 'prioritized.list.no.today.items',
        defaultMessage:
            'Nothing for today. Items that have been scheduled for today, or pinned, will appear here automatically.',
    },
    'prioritized.list.no.undated.items': {
        id: 'prioritized.list.no.undated.items',
        defaultMessage:
            'Nothing without a date. Items get listed here when you prioritize them without picking a target day.',
    },
    'prioritized.list.parent.heading': {
        id: 'prioritized.list.parent.heading',
        defaultMessage: 'Parent',
    },
    'prioritized.list.reindexing': {
        id: 'prioritized.list.reindexing',
        defaultMessage: 'Re-indexing items...',
    },
    'prioritized.list.target.date.heading': {
        id: 'prioritized.list.target.date.heading',
        defaultMessage: 'Target Date',
    },
    'profile.edit.field.not.empty': {
        id: 'profile.edit.field.not.empty',
        defaultMessage: 'This field cannot be empty.',
    },
    'profile.edit.invalid.email': {
        id: 'profile.edit.invalid.email',
        defaultMessage: 'Invalid email address format.',
    },
    'profile.edit.save.success': {
        id: 'profile.edit.save.success',
        defaultMessage: 'Information saved successfully.',
    },
    'search.label': {
        id: 'search.label',
        defaultMessage: 'Search',
    },
    'settings.modal.add.reminder': {
        id: 'settings.modal.add.reminder',
        defaultMessage: 'Add a Reminder',
    },
    'settings.modal.app.nav.customizations': {
        id: 'settings.modal.app.nav.customizations',
        defaultMessage: 'Customizations',
    },
    'settings.modal.app.nav.database': {
        id: 'settings.modal.app.nav.database',
        defaultMessage: 'Database',
    },
    'slack.connect.button': {
        id: 'slack.connect.button',
        defaultMessage: 'Connect Slack',
    },
    'slack.connected.on': {
        id: 'slack.connected.on',
        defaultMessage: 'Connected {date}',
    },
    'slack.disconnect': {
        id: 'slack.disconnect',
        defaultMessage: 'Disconnect',
    },
    'slack.disconnect.cancel': {
        id: 'slack.disconnect.cancel',
        defaultMessage: 'Keep connection',
    },
    'slack.disconnect.confirm': {
        id: 'slack.disconnect.confirm',
        defaultMessage: 'Disconnect Slack',
    },
    'slack.disconnect.msg': {
        id: 'slack.disconnect.msg',
        defaultMessage:
            'Captures from Slack will stop reaching this account. You can connect again at any time.',
    },
    'oauth.consent.title': {
        id: 'oauth.consent.title',
        defaultMessage: 'Connect to tidee?',
    },
    'oauth.consent.intro': {
        id: 'oauth.consent.intro',
        defaultMessage:
            'The application {clientName} wants to connect to your tidee account. Only continue if you want to give this application the following permissions to your account:',
    },
    'oauth.consent.scope.capture': {
        id: 'oauth.consent.scope.capture',
        defaultMessage: 'Add items to your workspace',
    },
    'oauth.consent.scope.items.read': {
        id: 'oauth.consent.scope.items.read',
        defaultMessage: 'Read your items and boxes',
    },
    'oauth.consent.scope.items.write': {
        id: 'oauth.consent.scope.items.write',
        defaultMessage: 'Create, edit and complete your items',
    },
    'oauth.consent.approve': {
        id: 'oauth.consent.approve',
        defaultMessage: 'Connect',
    },
    'oauth.consent.deny': {
        id: 'oauth.consent.deny',
        defaultMessage: 'Cancel',
    },
    'oauth.consent.footer': {
        id: 'oauth.consent.footer',
        defaultMessage:
            'You can disconnect it at any time in Application Settings, under Integrations.',
    },
    'oauth.consent.error.title': {
        id: 'oauth.consent.error.title',
        defaultMessage: 'This request is not valid',
    },
    'oauth.consent.error.msg': {
        id: 'oauth.consent.error.msg',
        defaultMessage:
            'The request has expired or was not understood. Start again from the application you are connecting.',
    },
    'oauth.grants.title': {
        id: 'oauth.grants.title',
        defaultMessage: 'Connected applications',
    },
    'oauth.grants.intro': {
        id: 'oauth.grants.intro',
        defaultMessage:
            'Applications you have connected to tidee. Each one can only do what you approved, and stops working the moment you disconnect it.',
    },
    'oauth.grants.help': {
        id: 'oauth.grants.help',
        defaultMessage:
            'To connect Claude or another AI assistant, see <link>Connect an assistant</link>.',
    },
    'oauth.grants.none': {
        id: 'oauth.grants.none',
        defaultMessage: 'No applications are connected.',
    },
    'oauth.grants.connected.on': {
        id: 'oauth.grants.connected.on',
        defaultMessage: 'Connected {date}',
    },
    'oauth.grants.last.used': {
        id: 'oauth.grants.last.used',
        defaultMessage: 'Last used {date}',
    },
    'oauth.grants.never.used': {
        id: 'oauth.grants.never.used',
        defaultMessage: 'Never used',
    },
    // A connection's identity. clientName is whatever the application
    // called itself, and several legitimately share one — so the label
    // is the only field that answers "which of these is my work
    // laptop", and the addresses are the only ones that answer "where
    // is this thing actually running".
    'oauth.grants.label.add': {
        id: 'oauth.grants.label.add',
        defaultMessage: 'Add a name',
    },
    'oauth.grants.label.edit': {
        id: 'oauth.grants.label.edit',
        defaultMessage: 'Rename',
    },
    'oauth.grants.label.placeholder': {
        id: 'oauth.grants.label.placeholder',
        defaultMessage: 'e.g. work laptop',
    },
    'oauth.grants.label.hint': {
        id: 'oauth.grants.label.hint',
        defaultMessage:
            'A name only you see, to tell connections of the same application apart.',
    },
    'oauth.grants.label.error': {
        id: 'oauth.grants.label.error',
        defaultMessage: "Couldn't save that name. Please try again.",
    },
    // "First connected from" rather than "connected from": it records
    // where the application registered, which is not necessarily where
    // it runs — set one up over a VPN and this names that network.
    'oauth.grants.registered.from': {
        id: 'oauth.grants.registered.from',
        defaultMessage: 'First connected from {ip}',
    },
    'oauth.grants.last.used.from': {
        id: 'oauth.grants.last.used.from',
        defaultMessage: 'Last used {date} from {ip}',
    },
    'oauth.grants.disconnect': {
        id: 'oauth.grants.disconnect',
        defaultMessage: 'Disconnect',
    },
    'oauth.grants.disconnect.title': {
        id: 'oauth.grants.disconnect.title',
        defaultMessage: 'Disconnect this application?',
    },
    'oauth.grants.disconnect.msg': {
        id: 'oauth.grants.disconnect.msg',
        defaultMessage:
            'It will stop being able to reach your workspace straight away. You can connect it again later.',
    },
    'oauth.grants.disconnect.confirm': {
        id: 'oauth.grants.disconnect.confirm',
        defaultMessage: 'Disconnect',
    },
    'oauth.grants.disconnect.cancel': {
        id: 'oauth.grants.disconnect.cancel',
        defaultMessage: 'Keep connected',
    },
    'slack.disconnect.title': {
        id: 'slack.disconnect.title',
        defaultMessage: 'Disconnect Slack?',
    },
    'slack.intro': {
        id: 'slack.intro',
        defaultMessage:
            'Connect Slack to capture straight from a conversation. Use {slashCommand} anywhere, or mention {mention} in a channel the app has been added to.',
    },
    'slack.none': {
        id: 'slack.none',
        defaultMessage: 'Slack is not connected to this account yet.',
    },
    'slack.title': {
        id: 'slack.title',
        defaultMessage: 'Slack',
    },
    'slack.workspace': {
        id: 'slack.workspace',
        defaultMessage: 'Workspace {teamId}',
    },
    'settings.modal.app.nav.integrations': {
        id: 'settings.modal.app.nav.integrations',
        defaultMessage: 'Integrations',
    },
    'settings.modal.app.nav.profile': {
        id: 'settings.modal.app.nav.profile',
        defaultMessage: 'Profile',
    },
    'settings.modal.app.nav.support': {
        id: 'settings.modal.app.nav.support',
        defaultMessage: 'Support',
    },
    'settings.modal.app.nav.blocked': {
        id: 'settings.modal.app.nav.blocked',
        defaultMessage: 'Blocked people',
    },
    // Mirrors the mobile Blocked people screen
    // (mobile.settings.blocked.*). Blocking is destructive — it
    // removes what that person had already shared — so there has to be
    // somewhere to see what you have done and undo the block itself.
    'settings.blocked.title': {
        id: 'settings.blocked.title',
        defaultMessage: 'Blocked people',
    },
    'settings.blocked.intro': {
        id: 'settings.blocked.intro',
        defaultMessage:
            'These people cannot share items with you, and you cannot share with them. Unblocking does not bring back anything that was removed — they would need to share it again.',
    },
    'settings.blocked.empty': {
        id: 'settings.blocked.empty',
        defaultMessage:
            'You have not blocked anyone. Blocking someone stops them sharing with you.',
    },
    'settings.blocked.unblock': {
        id: 'settings.blocked.unblock',
        defaultMessage: 'Unblock',
    },
    'settings.blocked.unblock.error': {
        id: 'settings.blocked.unblock.error',
        defaultMessage: "Couldn't unblock that person. Please try again.",
    },
    'settings.blocked.load.error': {
        id: 'settings.blocked.load.error',
        defaultMessage: "Couldn't load your blocked people. Please try again.",
    },
    // A block made against an address belonging to somebody with no
    // account has no name to show.
    'settings.blocked.since': {
        id: 'settings.blocked.since',
        defaultMessage: 'Blocked {date}',
    },
    'settings.modal.archive.box.msg': {
        id: 'settings.modal.archive.box.msg',
        defaultMessage: 'This will permanently archive this Box.',
    },
    'settings.modal.archive.item.msg': {
        id: 'settings.modal.archive.item.msg',
        defaultMessage: 'This will permanently archive this Item.',
    },
    'settings.modal.archive.options': {
        id: 'settings.modal.archive.options',
        defaultMessage: 'Archive options',
    },
    'settings.modal.archived.msg': {
        id: 'settings.modal.archived.msg',
        defaultMessage: 'This item was archived on {archivedDate}.',
    },
    'settings.modal.auto.add.to.unprioritized': {
        id: 'settings.modal.auto.add.to.unprioritized',
        defaultMessage: 'Automatically add new items to my Backlog',
    },
    'settings.modal.box.for.title': {
        id: 'settings.modal.box.for.title',
        defaultMessage: 'Box settings',
    },
    'settings.modal.customizations.toggle.tooltips': {
        id: 'settings.modal.customizations.toggle.tooltips',
        defaultMessage: 'Enable tooltips',
    },
    'settings.modal.customizations.toggle.tooltips.error': {
        id: 'settings.modal.customizations.toggle.tooltips.error',
        defaultMessage: 'Failed to update tooltips setting.',
    },
    'settings.modal.database.reseed.base.button': {
        id: 'settings.modal.database.reseed.base.button',
        defaultMessage: 'Re-seed (base)',
    },
    'settings.modal.database.reseed.full.button': {
        id: 'settings.modal.database.reseed.full.button',
        defaultMessage: 'Re-seed (full)',
    },
    'settings.modal.database.reseed.intro': {
        id: 'settings.modal.database.reseed.intro',
        defaultMessage: 'This will re-seed the database.',
    },
    'settings.modal.favourite.tooltip': {
        id: 'settings.modal.favourite.tooltip',
        defaultMessage: 'Add to Favorites',
    },
    'settings.modal.unfavourite.tooltip': {
        id: 'settings.modal.unfavourite.tooltip',
        defaultMessage: 'Remove from Favorites',
    },
    'settings.modal.fetching.item.details': {
        id: 'settings.modal.fetching.item.details',
        defaultMessage: 'Fetching item details...',
    },
    'settings.modal.item.for.title': {
        id: 'settings.modal.item.for.title',
        defaultMessage: 'Item settings',
    },
    'settings.modal.item.history': {
        id: 'settings.modal.item.history',
        defaultMessage: 'History',
    },
    'settings.modal.item.history.created': {
        id: 'settings.modal.item.history.created',
        defaultMessage: 'Created {date}',
    },
    'settings.modal.item.history.created.by': {
        id: 'settings.modal.item.history.created.by',
        defaultMessage: 'Created {date} by {userName}',
    },
    'settings.modal.item.history.updated': {
        id: 'settings.modal.item.history.updated',
        defaultMessage: 'Last updated {date}',
    },
    'settings.modal.item.history.updated.by': {
        id: 'settings.modal.item.history.updated.by',
        defaultMessage: 'Last updated {date} by {userName}',
    },
    'settings.modal.box.move': {
        id: 'settings.modal.box.move',
        defaultMessage: 'Move Box',
    },
    'settings.modal.box.move.intro': {
        id: 'settings.modal.box.move.intro',
        defaultMessage:
            "To move this box to another box, navigate your workspace and click 'Move'.",
    },
    'settings.modal.item.move': {
        id: 'settings.modal.item.move',
        defaultMessage: 'Move Item',
    },
    'settings.modal.item.move.intro': {
        id: 'settings.modal.item.move.intro',
        defaultMessage:
            "To move this item to another box, navigate your workspace and click 'Move'.",
    },
    'settings.modal.item.prioritizable': {
        id: 'settings.modal.item.prioritizable',
        defaultMessage: 'Prioritize',
    },
    'settings.modal.item.reminders.intro': {
        id: 'settings.modal.item.reminders.intro',
        defaultMessage:
            'Get reminded about this item. Reminders are relative to the above target date.',
    },
    'settings.modal.item.add.share': {
        id: 'settings.modal.item.add.share',
        defaultMessage: 'Add a new Share',
    },
    'settings.modal.item.add.share.intro': {
        id: 'settings.modal.item.add.share.intro',
        defaultMessage:
            'To allow someone access to this item, type their name or email address in the search field below. The search will be limited to organizations that you have access to.',
    },
    'settings.modal.item.edit.share': {
        id: 'settings.modal.item.edit.share',
        defaultMessage: 'Edit Share',
    },
    'settings.modal.item.share': {
        id: 'settings.modal.item.share',
        defaultMessage: 'Share',
    },
    'settings.modal.parent.box': {
        id: 'settings.modal.parent.box',
        defaultMessage: 'Parent Box',
    },
    'settings.modal.parent.box.workspace': {
        id: 'settings.modal.parent.box.workspace',
        defaultMessage: 'Workspace',
    },
    'settings.modal.item.target.date': {
        id: 'settings.modal.item.target.date',
        defaultMessage: 'Target Date',
    },
    'settings.modal.item.target.date.intro': {
        id: 'settings.modal.item.target.date.intro',
        defaultMessage: 'Set the date that you want to complete this task by.',
    },
    'settings.modal.item.target.date.set': {
        id: 'settings.modal.item.target.date.set',
        defaultMessage: 'Set date',
    },
    'settings.modal.item.target.date.clear': {
        id: 'settings.modal.item.target.date.clear',
        defaultMessage: 'Clear',
    },
    'settings.modal.item.target.date.none': {
        id: 'settings.modal.item.target.date.none',
        defaultMessage: 'No target date',
    },
    'settings.modal.language.save.error.msg': {
        id: 'settings.modal.language.save.error.msg',
        defaultMessage: 'There was a problem switching languages.',
    },
    'settings.modal.make.prioritizable.off': {
        id: 'settings.modal.make.prioritizable.off',
        defaultMessage: 'Surface this item in your Prioritized list.',
    },
    'settings.modal.make.prioritizable.on': {
        id: 'settings.modal.make.prioritizable.on',
        defaultMessage: 'Hide this item from your Prioritized list.',
    },
    'settings.modal.personal.details.language.intro': {
        id: 'settings.modal.personal.details.language.intro',
        defaultMessage:
            'Change the language (changing this will cause the application to refresh)',
    },
    'settings.modal.personal.details.password.intro': {
        id: 'settings.modal.personal.details.password.intro',
        defaultMessage:
            "Enter a new password into the field below and click 'Save'.",
    },
    'settings.modal.personal.details.morningPush.error.update': {
        id: 'settings.modal.personal.details.morningPush.error.update',
        defaultMessage: 'Failed to update daily summary notification.',
    },
    'settings.modal.personal.details.morningPush.intro': {
        id: 'settings.modal.personal.details.morningPush.intro',
        defaultMessage:
            'Pick a time each day to be notified of items in your Today list and any reminders firing that day.',
    },
    'settings.modal.personal.details.morningPush.off': {
        id: 'settings.modal.personal.details.morningPush.off',
        defaultMessage: 'Off',
    },
    'settings.modal.personal.details.title.language': {
        id: 'settings.modal.personal.details.title.language',
        defaultMessage: 'Language',
    },
    'settings.modal.personal.details.title.morningPush': {
        id: 'settings.modal.personal.details.title.morningPush',
        defaultMessage: 'Daily summary notification',
    },
    'settings.modal.personal.details.title.password': {
        id: 'settings.modal.personal.details.title.password',
        defaultMessage: 'Password',
    },
    'settings.modal.profile.field.label.timezone': {
        id: 'settings.modal.profile.field.label.timezone',
        defaultMessage: 'Timezone',
    },
    'settings.modal.profile.save.error.msg': {
        id: 'settings.modal.profile.save.error.msg',
        defaultMessage:
            'There was a problem saving your profile. Please try again later.',
    },
    'settings.modal.profile.saved.msg': {
        id: 'settings.modal.profile.saved.msg',
        defaultMessage: 'Your profile has been saved',
    },
    'settings.modal.reminders.markAllAsRead': {
        id: 'settings.modal.reminders.markAllAsRead',
        defaultMessage: 'Mark all <b>{count}</b> as read',
    },
    'settings.modal.reminders.no.events': {
        id: 'settings.modal.reminders.no.events',
        defaultMessage:
            'You do not have any past reminder events. Events will only appear in this list when they are due.',
    },
    'settings.modal.reminders.title': {
        id: 'settings.modal.reminders.title',
        defaultMessage: 'Reminders',
    },
    'settings.modal.restore.button': {
        id: 'settings.modal.restore.button',
        defaultMessage: 'Restore',
    },
    'settings.modal.restore.instructions': {
        id: 'settings.modal.restore.instructions',
        defaultMessage:
            'To restore it, select the box that you want to restore it to.',
    },
    'settings.modal.restore.options': {
        id: 'settings.modal.restore.options',
        defaultMessage: 'Restore options',
    },
    'settings.modal.share.add.button': {
        id: 'settings.modal.share.add.button',
        defaultMessage: 'Add a new Share',
    },
    'settings.modal.share.add.add.button': {
        id: 'settings.modal.share.add.add.button',
        defaultMessage: 'Add',
    },
    'settings.modal.share.add.cancel.button': {
        id: 'settings.modal.share.add.cancel.button',
        defaultMessage: 'Cancel',
    },
    'settings.modal.share.capabilities.intro': {
        id: 'settings.modal.share.capabilities.intro',
        defaultMessage: 'Capabilities of this ownership level:',
    },
    'settings.modal.share.edit.cancel.button': {
        id: 'settings.modal.share.edit.cancel.button',
        defaultMessage: 'Cancel',
    },
    'settings.modal.share.edit.save.button': {
        id: 'settings.modal.share.edit.save.button',
        defaultMessage: 'Save',
    },
    'settings.modal.share.intro': {
        id: 'settings.modal.share.intro',
        defaultMessage:
            'Share this item with other people across your organization(s).',
    },
    'settings.modal.share.list.table.col.name': {
        id: 'settings.modal.share.list.table.col.name',
        defaultMessage: 'Name',
    },
    'settings.modal.share.list.table.col.ownership': {
        id: 'settings.modal.share.list.table.col.ownership',
        defaultMessage: 'Ownership',
    },
    'settings.modal.share.no.shares': {
        id: 'settings.modal.share.no.shares',
        defaultMessage: "You haven't shared this with anyone yet.",
    },
    'settings.modal.share.list.title': {
        id: 'settings.modal.share.list.title',
        defaultMessage: 'People with access',
    },
    'settings.modal.share.section.title.item': {
        id: 'settings.modal.share.section.title.item',
        defaultMessage: 'Share this item',
    },
    'settings.modal.share.section.title.box': {
        id: 'settings.modal.share.section.title.box',
        defaultMessage: 'Share this box',
    },
    'settings.modal.share.owner': {
        id: 'settings.modal.share.owner',
        defaultMessage: 'Owner',
    },
    'settings.modal.share.source.direct': {
        id: 'settings.modal.share.source.direct',
        defaultMessage: 'Set on this item',
    },
    'settings.modal.share.source.box': {
        id: 'settings.modal.share.source.box',
        defaultMessage: 'Inherited from box "{boxTitle}"',
    },
    'settings.modal.share.source.box.untitled': {
        id: 'settings.modal.share.source.box.untitled',
        defaultMessage: 'Inherited from a box',
    },
    'settings.modal.share.source.org': {
        id: 'settings.modal.share.source.org',
        defaultMessage: 'Everyone in {orgName}',
    },
    'settings.modal.share.source.org.untitled': {
        id: 'settings.modal.share.source.org.untitled',
        defaultMessage: 'Everyone in this organization',
    },
    'settings.modal.share.action.open.box': {
        id: 'settings.modal.share.action.open.box',
        defaultMessage: 'Open box',
    },
    'settings.modal.share.action.edit': {
        id: 'settings.modal.share.action.edit',
        defaultMessage: 'Edit',
    },
    'settings.modal.share.action.remove': {
        id: 'settings.modal.share.action.remove',
        defaultMessage: 'Remove',
    },
    'settings.modal.share.email.label': {
        id: 'settings.modal.share.email.label',
        defaultMessage: 'Recipient email',
    },
    'settings.modal.share.ownership.label': {
        id: 'settings.modal.share.ownership.label',
        defaultMessage: 'Permission',
    },
    'settings.modal.share.ownership.placeholder': {
        id: 'settings.modal.share.ownership.placeholder',
        defaultMessage: 'Choose a permission level…',
    },
    'settings.modal.share.ownership.scope.hint': {
        id: 'settings.modal.share.ownership.scope.hint',
        defaultMessage:
            'Applies to every email and organization you selected above.',
    },
    'settings.modal.share.submitting': {
        id: 'settings.modal.share.submitting',
        defaultMessage: 'Sharing…',
    },
    'settings.modal.share.added.success': {
        id: 'settings.modal.share.added.success',
        defaultMessage: 'Shared with {email}.',
    },
    'settings.modal.share.already.shared': {
        id: 'settings.modal.share.already.shared',
        defaultMessage: 'Already shared with {email}.',
    },
    'settings.modal.share.removed.success': {
        id: 'settings.modal.share.removed.success',
        defaultMessage: 'Share removed.',
    },
    'settings.modal.share.updated.success': {
        id: 'settings.modal.share.updated.success',
        defaultMessage: "{name}'s permission updated.",
    },
    'settings.modal.share.stepped.down.success': {
        id: 'settings.modal.share.stepped.down.success',
        defaultMessage:
            "You've stepped down as an Owner and are now an Editor.",
    },
    'settings.modal.share.step.down.button': {
        id: 'settings.modal.share.step.down.button',
        defaultMessage: 'Step down as Owner',
    },
    'settings.modal.share.step.down.confirm.title': {
        id: 'settings.modal.share.step.down.confirm.title',
        defaultMessage: 'Step down as Owner?',
    },
    'settings.modal.share.step.down.confirm.body': {
        id: 'settings.modal.share.step.down.confirm.body',
        defaultMessage:
            "You'll become an Editor. The other Owners keep their access. You can be promoted back to Owner later.",
    },
    'settings.modal.share.step.down.confirm.button': {
        id: 'settings.modal.share.step.down.confirm.button',
        defaultMessage: 'Step down',
    },
    'settings.modal.share.edit.title': {
        id: 'settings.modal.share.edit.title',
        defaultMessage: "Edit {name}'s access",
    },
    'settings.modal.share.edit.person.label': {
        id: 'settings.modal.share.edit.person.label',
        defaultMessage: 'Person',
    },
    'settings.modal.share.add.share.button': {
        id: 'settings.modal.share.add.share.button',
        defaultMessage: 'Add a share',
    },
    'settings.modal.share.pending.success': {
        id: 'settings.modal.share.pending.success',
        defaultMessage: 'Sent to {email}. They will see it once they accept.',
    },
    'settings.modal.share.invited.success': {
        id: 'settings.modal.share.invited.success',
        defaultMessage:
            'Invitation sent to {email}. They’ll get access once they sign up and verify their address.',
    },
    'settings.modal.share.invite.pending': {
        id: 'settings.modal.share.invite.pending',
        defaultMessage: 'Pending',
    },
    // Sits under the recipient's name in "People with access". Not the
    // same thing as invite.pending above: that is somebody with no
    // account yet, this is somebody who has one and has not answered.
    'settings.modal.share.pending.acceptance': {
        id: 'settings.modal.share.pending.acceptance',
        defaultMessage: '(Waiting to accept)',
    },
    'settings.modal.share.invite.invited': {
        id: 'settings.modal.share.invite.invited',
        defaultMessage: 'Invited {relativeTime}',
    },
    'settings.modal.share.invite.expires': {
        id: 'settings.modal.share.invite.expires',
        defaultMessage: 'expires {relativeTime}',
    },
    'settings.modal.share.invite.resend': {
        id: 'settings.modal.share.invite.resend',
        defaultMessage: 'Resend invitation',
    },
    'settings.modal.share.invite.resend.cooldown': {
        id: 'settings.modal.share.invite.resend.cooldown',
        defaultMessage: 'Resend available {relativeTime}',
    },
    'settings.modal.share.invite.resent.success': {
        id: 'settings.modal.share.invite.resent.success',
        defaultMessage: 'Invitation resent.',
    },
    'settings.modal.share.invite.revoked.success': {
        id: 'settings.modal.share.invite.revoked.success',
        defaultMessage: 'Invitation revoked.',
    },
    'settings.modal.share.notification.resend': {
        id: 'settings.modal.share.notification.resend',
        defaultMessage: 'Resend share email',
    },
    'settings.modal.share.notification.resend.cooldown': {
        id: 'settings.modal.share.notification.resend.cooldown',
        defaultMessage: 'Resend available {relativeTime}',
    },
    'settings.modal.share.notification.resent.success': {
        id: 'settings.modal.share.notification.resent.success',
        defaultMessage: 'Share email resent.',
    },
    'settings.modal.share.item.intro': {
        id: 'settings.modal.share.item.intro',
        defaultMessage:
            'Those that you share with will get access at the permission level you choose, and you can change or revoke it at any time.',
    },
    'settings.modal.share.box.intro': {
        id: 'settings.modal.share.box.intro',
        defaultMessage:
            'Those that you share with will get access to every item currently inside the box, AND any items you add to it later, at the permission level you choose. You can change or revoke access at any time.',
    },
    'settings.modal.share.list.item.intro': {
        id: 'settings.modal.share.list.item.intro',
        defaultMessage:
            'Share this item with other people. You can change or revoke access at any time.',
    },
    'settings.modal.share.list.box.intro': {
        id: 'settings.modal.share.list.box.intro',
        defaultMessage:
            "Share this box with other people. They'll get access to every item currently inside, AND any items you add to it later. You can change or revoke access at any time.",
    },
    'settings.modal.share.list.item.intro.readonly': {
        id: 'settings.modal.share.list.item.intro.readonly',
        defaultMessage:
            'This item was shared with you. Only the owner can manage who has access.',
    },
    'settings.modal.share.list.box.intro.readonly': {
        id: 'settings.modal.share.list.box.intro.readonly',
        defaultMessage:
            'This box was shared with you. Only the owner can manage who has access.',
    },
    'settings.modal.share.search.no.users.found': {
        id: 'settings.modal.share.search.no.users.found',
        defaultMessage: 'No users were found with this search term.',
    },
    'settings.modal.share.selected.person': {
        id: 'settings.modal.share.selected.person',
        defaultMessage: 'Selected person',
    },
    'settings.modal.share.users.intro': {
        id: 'settings.modal.share.users.intro',
        defaultMessage:
            'Below is a list of people that have access to this item, along with their level of ownership.',
    },
    'settings.modal.show.completed.option': {
        id: 'settings.modal.show.completed.option',
        defaultMessage: 'Show completed items',
    },
    // Account closure, at the foot of the Profile tab. Deletion is
    // refused while a blocker stands; the two blockers the user cannot
    // clear themselves say so rather than implying a retry will work.
    'settings.modal.account.delete.title': {
        id: 'settings.modal.account.delete.title',
        defaultMessage: 'Delete account',
    },
    'settings.modal.account.delete.ready': {
        id: 'settings.modal.account.delete.ready',
        defaultMessage:
            'Deleting your account permanently removes it and {count, plural, one {# item} other {# items}}. This cannot be undone.',
    },
    'settings.modal.account.delete.button': {
        id: 'settings.modal.account.delete.button',
        defaultMessage: 'Delete account',
    },
    'settings.modal.account.delete.confirm': {
        id: 'settings.modal.account.delete.confirm',
        defaultMessage:
            'This will delete your account and {count, plural, one {# item} other {# items}} straight away. There is no way back.',
    },
    'settings.modal.account.delete.confirm.button': {
        id: 'settings.modal.account.delete.confirm.button',
        defaultMessage: 'Yes, delete my account',
    },
    'settings.modal.account.delete.error': {
        id: 'settings.modal.account.delete.error',
        defaultMessage:
            "We couldn't delete your account. Please try again, and contact support if it keeps happening.",
    },
    // Resend feedback on an Outgoing row. Before these, the resend
    // handler was try/finally with no catch — so a refused resend, which
    // the 1-per-24h cooldown makes the common case, looked like a button
    // that did nothing.
    'shares.outgoing.resend.sent': {
        id: 'shares.outgoing.resend.sent',
        defaultMessage: 'Invitation sent again',
    },
    'shares.outgoing.resend.error': {
        id: 'shares.outgoing.resend.error',
        defaultMessage: "Couldn't resend — please try again",
    },
    'shares.outgoing.resend.cooldown': {
        id: 'shares.outgoing.resend.cooldown',
        defaultMessage: 'Can be sent again {when}',
    },
    'settings.modal.account.delete.view.shares.button': {
        id: 'settings.modal.account.delete.view.shares.button',
        defaultMessage: 'View my shared items',
    },
    'settings.modal.account.delete.recheck.button': {
        id: 'settings.modal.account.delete.recheck.button',
        defaultMessage: 'Check again',
    },
    'settings.modal.account.delete.blocked.intro': {
        id: 'settings.modal.account.delete.blocked.intro',
        defaultMessage:
            'Your account cannot be deleted yet. Here is what is in the way.',
    },
    // One plural block per message, and no pronoun agreement. An
    // earlier draft repeated {count, plural, …} three times in a
    // sentence to get "it"/"them" right; the translator could not
    // reproduce the placeholder set and fell back to English.
    'settings.modal.account.delete.blocked.shared': {
        id: 'settings.modal.account.delete.blocked.shared',
        defaultMessage:
            'You are sharing {count, plural, one {# item} other {# items}}. Stop sharing before you delete your account, or everyone you shared with will lose access.',
    },
    'settings.modal.account.delete.blocked.invites': {
        id: 'settings.modal.account.delete.blocked.invites',
        defaultMessage:
            'You have {count, plural, one {# invitation} other {# invitations}} nobody has accepted yet. Cancel them first, or the links you sent will stop working when your account goes.',
    },
    'settings.modal.account.delete.blocked.foreign': {
        id: 'settings.modal.account.delete.blocked.foreign',
        defaultMessage:
            'Your boxes hold {count, plural, one {# item} other {# items}} belonging to someone else. We will not delete another person’s work — ask the owner to move it somewhere of their own.',
    },
    'settings.modal.account.delete.blocked.orgs': {
        id: 'settings.modal.account.delete.blocked.orgs',
        defaultMessage:
            'You own {count, plural, one {# organisation} other {# organisations}}. Contact support to hand ownership over — deleting your account would close every organization you own and remove its members.',
    },
    // In-app contact-support form (Support tab in App Settings).
    'settings.modal.support.title': {
        id: 'settings.modal.support.title',
        defaultMessage: 'Contact support',
    },
    'settings.modal.support.intro': {
        id: 'settings.modal.support.intro',
        defaultMessage:
            "Send us a message and we'll reply to {email}, usually within one working day.",
    },
    'settings.modal.support.field.label': {
        id: 'settings.modal.support.field.label',
        defaultMessage: 'How can we help?',
    },
    'settings.modal.support.field.placeholder': {
        id: 'settings.modal.support.field.placeholder',
        defaultMessage: 'Describe your issue or question…',
    },
    'settings.modal.support.send': {
        id: 'settings.modal.support.send',
        defaultMessage: 'Send message',
    },
    'settings.modal.support.sent': {
        id: 'settings.modal.support.sent',
        defaultMessage:
            "Message sent. Thanks for getting in touch — we'll be in contact soon.",
    },
    'settings.modal.support.error': {
        id: 'settings.modal.support.error',
        defaultMessage: "Your message couldn't be sent. Please try again.",
    },
    'settings.modal.title': {
        id: 'settings.modal.title',
        defaultMessage: 'Application settings',
    },
    'settings.modal.title.customisations': {
        id: 'settings.modal.title.customisations',
        defaultMessage: 'Customizations',
    },
    'settings.modal.title.database': {
        id: 'settings.modal.title.database',
        defaultMessage: 'Database',
    },
    'settings.modal.title.personal.details': {
        id: 'settings.modal.title.personal.details',
        defaultMessage: 'Personal Details',
    },
    'settings.modal.workspace.title': {
        id: 'settings.modal.workspace.title',
        defaultMessage: 'Workspace Settings',
    },
    'signup.account.created': {
        id: 'signup.account.created',
        defaultMessage: 'To activate your account, please check your email.',
    },
    'signup.already.have.account': {
        id: 'signup.already.have.account',
        defaultMessage: 'Already have an account?',
    },
    'signup.create.account.btn.label': {
        id: 'signup.create.account.btn.label',
        defaultMessage: 'Create New Account',
    },
    'signup.organisation.invite.text': {
        id: 'signup.organisation.invite.text',
        defaultMessage:
            "You have been invited to join an organization on tidee, but it looks as though you don't have an account with us. Sign-up below in order to create a new account.",
    },
    'signup.success.check.text': {
        id: 'signup.success.check.text',
        defaultMessage:
            'We have sent you an email to activate this account. Check your inbox.',
    },
    'signup.success.confirmation.text': {
        id: 'signup.success.confirmation.text',
        defaultMessage: 'You have successfully signed up to tidee',
    },
    'tooltip.archive': {
        id: 'tooltip.archive',
        defaultMessage: 'Archive',
    },
    'tooltip.box.close': {
        id: 'tooltip.box.close',
        defaultMessage: 'Close',
    },
    'tooltip.box.settings': {
        id: 'tooltip.box.settings',
        defaultMessage: 'Box settings',
    },
    'tooltip.open.parent.box': {
        id: 'tooltip.open.parent.box',
        defaultMessage: 'Open parent box',
    },
    'tooltip.dive.down': {
        id: 'tooltip.dive.down',
        defaultMessage: 'Dive down (shift-click to open)',
    },
    'tooltip.edit': {
        id: 'tooltip.edit',
        defaultMessage: 'Edit',
    },
    'tooltip.insert.item': {
        id: 'tooltip.insert.item',
        defaultMessage: 'Insert item',
    },
    'tooltip.item.options': {
        id: 'tooltip.item.options',
        defaultMessage: 'Options',
    },
    'tooltip.item.settings': {
        id: 'tooltip.item.settings',
        defaultMessage: 'Item settings',
    },
    'tooltip.item.complete': {
        id: 'tooltip.item.complete',
        defaultMessage: 'Mark as complete',
    },
    'tooltip.item.uncomplete': {
        id: 'tooltip.item.uncomplete',
        defaultMessage: 'Mark as not complete',
    },
    'tooltip.organizer.open.parent.box': {
        id: 'tooltip.organizer.open.parent.box',
        defaultMessage: 'Open this box in the Workspace',
    },
    'settings.modal.item.completed.alert': {
        id: 'settings.modal.item.completed.alert',
        defaultMessage: 'Completed{byPart}{datePart}',
    },
    'tooltip.item.pin.to.today': {
        id: 'tooltip.item.pin.to.today',
        defaultMessage: 'Pin to Today',
    },
    'tooltip.item.unpin.from.today': {
        id: 'tooltip.item.unpin.from.today',
        defaultMessage: 'Unpin from Today',
    },
    'tooltip.more.options': {
        id: 'tooltip.more.options',
        defaultMessage: 'More options',
    },
    'tooltip.pane.search': {
        id: 'tooltip.pane.search',
        defaultMessage: 'Insert pane...',
    },
    'tooltip.search.result.open': {
        id: 'tooltip.search.result.open',
        defaultMessage: 'Open in this pane (shift-click for a new pane)',
    },
    'tooltip.prioritize': {
        id: 'tooltip.prioritize',
        // Baseline: clicking prioritize on an item WITHOUT today-signals
        // (markedAsForToday false, no priorityTargetDate) sets
        // prioritizable=true without a priority, landing the item in
        // Backlog. Items WITH today-signals use the alternate copy
        // (tooltip.add.to.prioritised.list) because the server's
        // auto-priority hook promotes them straight to the Prioritised
        // list on the same click.
        defaultMessage: 'Add to Backlog',
    },
    'tooltip.add.to.prioritised.list': {
        id: 'tooltip.add.to.prioritised.list',
        defaultMessage: 'Add to Prioritized list',
    },
    'tooltip.remove': {
        id: 'tooltip.remove',
        defaultMessage: 'Remove',
    },
    'tooltip.share': {
        id: 'tooltip.share',
        defaultMessage: 'Share',
    },
    'tooltip.target.date': {
        id: 'tooltip.target.date',
        defaultMessage: 'Target date',
    },
    'tooltip.unprioritize': {
        id: 'tooltip.unprioritize',
        defaultMessage: 'Remove from Prioritized list',
    },
    'tooltip.remove.from.backlog': {
        id: 'tooltip.remove.from.backlog',
        defaultMessage: 'Remove from Backlog',
    },
    'unprioritized.list.created.title': {
        id: 'unprioritized.list.created.title',
        defaultMessage: 'Created',
    },
    'unprioritized.list.item.save.failure': {
        id: 'unprioritized.list.item.save.failure',
        defaultMessage: 'Text details could not be saved.',
    },
    'unprioritized.list.item.title': {
        id: 'unprioritized.list.item.title',
        defaultMessage: 'Item',
    },
    'unprioritized.list.no.items': {
        id: 'unprioritized.list.no.items',
        defaultMessage:
            "Your Backlog is empty. Items you create and do not add a target date to, or pin to today's date, will appear here. You can routinely visit this page to prioritize remaining items.",
    },
    'unprioritized.list.num.items': {
        id: 'unprioritized.list.num.items',
        defaultMessage: 'items',
    },
    'unprioritized.list.parent.title': {
        id: 'unprioritized.list.parent.title',
        defaultMessage: 'Parent',
    },
    'unprioritized.list.target.date.title': {
        id: 'unprioritized.list.target.date.title',
        defaultMessage: 'Target Date',
    },
    'unprioritized.list.unprioritized.title': {
        id: 'unprioritized.list.unprioritized.title',
        defaultMessage: 'Backlog',
    },
    'validator.invalid.email': {
        id: 'validator.invalid.email',
        defaultMessage: 'Invalid email address.',
    },
    'validator.invalid.password': {
        id: 'validator.invalid.password',
        defaultMessage:
            'Your password must be between 8 and 15 characters long, contain at least one lowercase letter, one uppercase letter, one numeric digit and one special character.',
    },
    'validator.non.empty.string': {
        id: 'validator.non.empty.string',
        defaultMessage: 'Cannot be empty.',
    },
    'validator.organisation.name.msg': {
        id: 'validator.organisation.name.msg',
        defaultMessage: 'Organization name is not valid.',
    },
    'validator.organisation.updated': {
        id: 'validator.organisation.updated',
        defaultMessage: 'Organization has been updated.',
    },
    'workspace.label': {
        id: 'workspace.label',
        defaultMessage: 'Workspace',
    },
    'workspace.settings.modal.item.options': {
        id: 'workspace.settings.modal.item.options',
        defaultMessage: 'Options',
    },
    'global.search.placeholder': {
        id: 'global.search.placeholder',
        defaultMessage: 'Search',
    },
    'global.search.modal.title': {
        id: 'global.search.modal.title',
        defaultMessage: 'Search',
    },
    'global.search.modal.intro': {
        id: 'global.search.modal.intro',
        defaultMessage: 'Type your search term or use voice recognition.',
    },
    'global.search.modal.no.results': {
        id: 'global.search.modal.no.results',
        defaultMessage: 'No results found',
    },
    'global.search.tooltip': {
        id: 'global.search.tooltip',
        defaultMessage: 'Search for items',
    },
    'global.search.voice.tooltip': {
        id: 'global.search.voice.tooltip',
        defaultMessage: 'Search by voice',
    },
    'global.search.clear.tooltip': {
        id: 'global.search.clear.tooltip',
        defaultMessage: 'Clear search',
    },
    'global.search.placeholder.listening': {
        id: 'global.search.placeholder.listening',
        defaultMessage: 'Listening...',
    },
    'voice.recognition.error.language.not.supported': {
        id: 'voice.recognition.error.language.not.supported',
        defaultMessage:
            "Voice recognition isn't supported for the current app language in your browser. Try switching the app language or using a different browser.",
    },
    'voice.recognition.error.not.allowed': {
        id: 'voice.recognition.error.not.allowed',
        defaultMessage:
            'Microphone access is blocked. Allow microphone access for this site in your browser settings to use voice input.',
    },
    'voice.recognition.error.audio.capture': {
        id: 'voice.recognition.error.audio.capture',
        defaultMessage:
            "No microphone was found. Connect a microphone and try again, or check that it isn't being used by another application.",
    },
    'sidebar.prioritized.label': {
        id: 'sidebar.prioritized.label',
        defaultMessage: 'Prioritized list',
    },
    'sidebar.backlog.label': {
        id: 'sidebar.backlog.label',
        defaultMessage: 'Backlog',
    },
    'sidebar.workspace.label': {
        id: 'sidebar.workspace.label',
        defaultMessage: 'Workspace',
    },
    // "Shared items" in all four places this concept is named: the web
    // sidebar and page heading here, and mobile's Settings row and
    // screen header (mobile.settings.shares.row.label). Separate keys
    // because the surfaces are separate, so they have to be kept in
    // step by hand.
    'sidebar.shares.label': {
        id: 'sidebar.shares.label',
        defaultMessage: 'Shared items',
    },
    'shares.page.title': {
        id: 'shares.page.title',
        defaultMessage: 'Shared items',
    },
    'shares.page.intro': {
        id: 'shares.page.intro',
        defaultMessage:
            'Below is a list of items that have been either shared by you or shared with you.',
    },
    'shares.tab.incoming': {
        id: 'shares.tab.incoming',
        defaultMessage: 'Shared with me',
    },
    'shares.tab.outgoing': {
        id: 'shares.tab.outgoing',
        defaultMessage: 'Shared by me',
    },
    'shares.incoming.empty': {
        id: 'shares.incoming.empty',
        defaultMessage: 'Nothing has been shared with you yet.',
    },
    'shares.outgoing.empty': {
        id: 'shares.outgoing.empty',
        defaultMessage: "You haven't shared anything yet.",
    },
    'shares.incoming.load.error': {
        id: 'shares.incoming.load.error',
        defaultMessage: "Couldn't load your incoming shares. Please try again.",
    },
    'shares.incoming.group.direct': {
        id: 'shares.incoming.group.direct',
        defaultMessage: 'Shared directly with you',
    },
    'shares.incoming.group.org': {
        id: 'shares.incoming.group.org',
        defaultMessage: 'Shared through {orgName}',
    },
    'shares.incoming.placement.root': {
        id: 'shares.incoming.placement.root',
        defaultMessage: 'Workspace',
    },
    'shares.incoming.row.placedIn': {
        id: 'shares.incoming.row.placedIn',
        defaultMessage: 'In {placement}',
    },
    'shares.incoming.action.open.tooltip': {
        id: 'shares.incoming.action.open.tooltip',
        defaultMessage: 'Open in your Workspace',
    },
    // Guideline 1.2 safety controls. See docs/SHARE_SAFETY_CONTROLS.md.
    'shares.incoming.action.reported': {
        id: 'shares.incoming.action.reported',
        defaultMessage: 'Reported',
    },
    'shares.report.already': {
        id: 'shares.report.already',
        defaultMessage:
            'You have already reported this. We are looking into it.',
    },
    'shares.incoming.action.accept': {
        id: 'shares.incoming.action.accept',
        defaultMessage: 'Accept',
    },
    'shares.incoming.action.decline': {
        id: 'shares.incoming.action.decline',
        defaultMessage: 'Decline',
    },
    'shares.incoming.pending.note': {
        id: 'shares.incoming.pending.note',
        defaultMessage: '{name} wants to share this with you',
    },
    'shares.accept.error': {
        id: 'shares.accept.error',
        defaultMessage: "Couldn't accept that share. Please try again.",
    },
    'shares.decline.error': {
        id: 'shares.decline.error',
        defaultMessage: "Couldn't decline that share. Please try again.",
    },
    // Bracketed to match its sibling shares.outgoing.invite.pending
    // ('(pending)'): both render in the same Span, in the same place
    // after the recipient's name, and to the sender they are the same
    // situation — sent, not yet landed. The brackets live in the
    // string rather than the JSX so a locale can punctuate an aside
    // its own way.
    'shares.outgoing.pending': {
        id: 'shares.outgoing.pending',
        defaultMessage: '(Waiting for them to accept)',
    },
    'shares.incoming.action.report': {
        id: 'shares.incoming.action.report',
        defaultMessage: 'Report',
    },
    'shares.incoming.action.block': {
        id: 'shares.incoming.action.block',
        defaultMessage: 'Block',
    },
    'shares.block.confirm.title': {
        id: 'shares.block.confirm.title',
        defaultMessage: 'Block {name}?',
    },
    'shares.block.confirm.body': {
        id: 'shares.block.confirm.body',
        defaultMessage:
            'They will not be able to share anything with you, and anything they have already shared will be removed from your account. You can unblock them later, but the removed items will not come back.',
    },
    'shares.report.modal.title': {
        id: 'shares.report.modal.title',
        defaultMessage: 'Report this item',
    },
    'shares.report.modal.body': {
        id: 'shares.report.modal.body',
        defaultMessage:
            'Tell us what is wrong with it and we will look into it.',
    },
    'shares.report.sent': {
        id: 'shares.report.sent',
        defaultMessage: 'Thank you. We have received your report.',
    },
    'shares.report.error': {
        id: 'shares.report.error',
        defaultMessage: "Couldn't send that report. Please try again.",
    },
    'shares.block.error': {
        id: 'shares.block.error',
        defaultMessage: "Couldn't block that person. Please try again.",
    },
    'shares.report.detail.label': {
        id: 'shares.report.detail.label',
        defaultMessage: 'Anything else we should know? (optional)',
    },
    'shares.report.detail.label.required': {
        id: 'shares.report.detail.label.required',
        defaultMessage: 'Tell us what is wrong',
    },
    'shares.report.detail.placeholder': {
        id: 'shares.report.detail.placeholder',
        defaultMessage: 'Add any detail that would help us review this.',
    },
    'shares.report.reason.label': {
        id: 'shares.report.reason.label',
        defaultMessage: 'Reason',
    },
    'shares.report.reason.placeholder': {
        id: 'shares.report.reason.placeholder',
        defaultMessage: 'Choose a reason',
    },
    'shares.report.reason.spam': {
        id: 'shares.report.reason.spam',
        defaultMessage: 'Spam or unwanted',
    },
    'shares.report.reason.harassment': {
        id: 'shares.report.reason.harassment',
        defaultMessage: 'Harassment or abuse',
    },
    'shares.report.reason.sexual': {
        id: 'shares.report.reason.sexual',
        defaultMessage: 'Sexual content',
    },
    'shares.report.reason.violence': {
        id: 'shares.report.reason.violence',
        defaultMessage: 'Violence or threats',
    },
    'shares.report.reason.other': {
        id: 'shares.report.reason.other',
        defaultMessage: 'Something else',
    },
    'shares.incoming.action.remove': {
        id: 'shares.incoming.action.remove',
        defaultMessage: 'Remove from workspace',
    },
    'shares.incoming.action.restore': {
        id: 'shares.incoming.action.restore',
        defaultMessage: 'Restore to workspace',
    },
    'shares.outgoing.load.error': {
        id: 'shares.outgoing.load.error',
        defaultMessage: "Couldn't load your outgoing shares. Please try again.",
    },
    'shares.outgoing.card.recipients': {
        id: 'shares.outgoing.card.recipients',
        defaultMessage:
            '{count, plural, one {# recipient} other {# recipients}}',
    },
    'shares.outgoing.invite.pending': {
        id: 'shares.outgoing.invite.pending',
        defaultMessage: '(pending)',
    },
    'shares.outgoing.action.revoke': {
        id: 'shares.outgoing.action.revoke',
        defaultMessage: 'Revoke',
    },
    'shares.outgoing.action.resend': {
        id: 'shares.outgoing.action.resend',
        defaultMessage: 'Resend',
    },
    'shares.outgoing.confirm.revoke.title': {
        id: 'shares.outgoing.confirm.revoke.title',
        defaultMessage: 'Revoke access?',
    },
    'shares.outgoing.confirm.revoke': {
        id: 'shares.outgoing.confirm.revoke',
        defaultMessage:
            'Revoke {recipient}’s access to “{itemTitle}”? They will no longer see or edit it.',
    },
    'shares.filter.search.placeholder': {
        id: 'shares.filter.search.placeholder',
        defaultMessage: 'Search shares…',
    },
    'shares.filter.no.results': {
        id: 'shares.filter.no.results',
        defaultMessage: 'No shares match your search.',
    },
    'shares.column.item': {
        id: 'shares.column.item',
        defaultMessage: 'Item',
    },
    'shares.column.from': {
        id: 'shares.column.from',
        defaultMessage: 'From',
    },
    'shares.column.with': {
        id: 'shares.column.with',
        defaultMessage: 'Shared with',
    },
    'shares.column.locatedIn': {
        id: 'shares.column.locatedIn',
        defaultMessage: 'Located In',
    },
    'shares.column.permission': {
        id: 'shares.column.permission',
        defaultMessage: 'Permission',
    },
    'shares.column.organisation': {
        id: 'shares.column.organisation',
        defaultMessage: 'Organization',
    },
    'shares.column.actions': {
        id: 'shares.column.actions',
        defaultMessage: 'Actions',
    },
    'shares.incoming.source.org.untitled': {
        id: 'shares.incoming.source.org.untitled',
        defaultMessage: 'Everyone in this organization',
    },
    'shares.incoming.source.unknown': {
        id: 'shares.incoming.source.unknown',
        defaultMessage: 'Unknown',
    },
    'sidebar.workspace.empty': {
        id: 'sidebar.workspace.empty',
        defaultMessage: 'Your workspace items will appear here when created.',
    },
    'sidebar.workspace.open.as.pane': {
        id: 'sidebar.workspace.open.as.pane',
        defaultMessage: 'Open workspace as a pane',
    },
    'sidebar.workspace.panes.label': {
        id: 'sidebar.workspace.panes.label',
        defaultMessage: 'Workspace panes',
    },
    'sidebar.workspace.panes.empty': {
        id: 'sidebar.workspace.panes.empty',
        defaultMessage:
            'No panes are open. Use the button above to open the workspace, then open a box to see it listed here.',
    },
    'sidebar.search.placeholder': {
        id: 'sidebar.search.placeholder',
        defaultMessage: 'Search boxes and items…',
    },
    'generic.button.remove': {
        id: 'generic.button.remove',
        defaultMessage: 'Remove',
    },
    'settings.verified.emails.title': {
        id: 'settings.verified.emails.title',
        defaultMessage: 'Verified email addresses',
    },
    'settings.verified.emails.intro': {
        id: 'settings.verified.emails.intro',
        defaultMessage:
            'Add other emails you own so shares and organization invites sent to any of them attach to this account.',
    },
    'settings.verified.emails.add.label': {
        id: 'settings.verified.emails.add.label',
        defaultMessage: 'Add another email',
    },
    'settings.verified.emails.send.button': {
        id: 'settings.verified.emails.send.button',
        defaultMessage: 'Send verification link',
    },
    'settings.verified.emails.sent.msg': {
        id: 'settings.verified.emails.sent.msg',
        defaultMessage:
            'Verification link sent to {email}. Check your inbox and follow the link to confirm.',
    },
    'settings.verified.emails.send.error.msg': {
        id: 'settings.verified.emails.send.error.msg',
        defaultMessage:
            "Couldn't send the verification link. Please try again.",
    },
    'settings.verified.emails.removed.msg': {
        id: 'settings.verified.emails.removed.msg',
        defaultMessage: '{email} removed.',
    },
    'settings.verified.emails.remove.error.msg': {
        id: 'settings.verified.emails.remove.error.msg',
        defaultMessage: "Couldn't remove that email. Please try again.",
    },
    'settings.verified.emails.pending.label': {
        id: 'settings.verified.emails.pending.label',
        defaultMessage: 'Pending verification',
    },
    'settings.verified.emails.pending.expires': {
        id: 'settings.verified.emails.pending.expires',
        defaultMessage: 'Link expires {when}',
    },
    'settings.verified.emails.pending.resend.button': {
        id: 'settings.verified.emails.pending.resend.button',
        defaultMessage: 'Resend',
    },
    'settings.verified.emails.pending.cancel.button': {
        id: 'settings.verified.emails.pending.cancel.button',
        defaultMessage: 'Cancel',
    },
    'settings.verified.emails.resent.msg': {
        id: 'settings.verified.emails.resent.msg',
        defaultMessage: 'Verification link re-sent to {email}.',
    },
    'settings.verified.emails.canceled.msg': {
        id: 'settings.verified.emails.canceled.msg',
        defaultMessage: 'Verification request for {email} canceled.',
    },
    'settings.verified.emails.cancel.error.msg': {
        id: 'settings.verified.emails.cancel.error.msg',
        defaultMessage:
            "Couldn't cancel the verification request. Please try again.",
    },
    'share.invite.loading': {
        id: 'share.invite.loading',
        defaultMessage: 'Looking up your invitation…',
    },
    'share.invite.intro': {
        id: 'share.invite.intro',
        defaultMessage: '{granter} invited you to see "{itemTitle}" on tidee.',
    },
    'share.invite.granter.unknown': {
        id: 'share.invite.granter.unknown',
        defaultMessage: 'A tidee user',
    },
    'share.invite.not.logged.in.sub': {
        id: 'share.invite.not.logged.in.sub',
        defaultMessage:
            'Sign up as {email}, or log in to an account that already uses that address, and the share will be added automatically.',
    },
    'share.invite.signup.cta': {
        id: 'share.invite.signup.cta',
        defaultMessage: 'Sign up',
    },
    'share.invite.login.cta': {
        id: 'share.invite.login.cta',
        defaultMessage: 'I already have a tidee account',
    },
    'share.invite.claiming': {
        id: 'share.invite.claiming',
        defaultMessage: 'Adding this share to your workspace…',
    },
    'share.invite.claimed': {
        id: 'share.invite.claimed',
        defaultMessage: '"{itemTitle}" has been added to your workspace.',
    },
    'share.invite.continue': {
        id: 'share.invite.continue',
        defaultMessage: 'Go to your workspace',
    },
    'share.invite.needs.verify': {
        id: 'share.invite.needs.verify',
        defaultMessage:
            'This invitation was sent to {email}. Verify that address on your account to add "{itemTitle}" to your workspace.',
    },
    'share.invite.request.verify.cta': {
        id: 'share.invite.request.verify.cta',
        defaultMessage: 'Add and verify this email',
    },
    'share.invite.verify.requested': {
        id: 'share.invite.verify.requested',
        defaultMessage: "We've sent a verification link to {email}.",
    },
    'share.invite.verify.requested.sub': {
        id: 'share.invite.verify.requested.sub',
        defaultMessage:
            'Click the link in that email to add this share to your workspace. You can close this page.',
    },
    'share.invite.back.to.workspace': {
        id: 'share.invite.back.to.workspace',
        defaultMessage: 'Back to your workspace',
    },
    'share.invite.go.login': {
        id: 'share.invite.go.login',
        defaultMessage: 'Go to log in',
    },
    'share.invite-not-found': {
        id: 'share.invite-not-found',
        defaultMessage: "That invitation link isn't valid.",
    },
    'share.invite-expired': {
        id: 'share.invite-expired',
        defaultMessage:
            'That invitation has expired. Ask the sender to send it again.',
    },
    'share.invite-item-gone': {
        id: 'share.invite-item-gone',
        defaultMessage:
            'The item this invitation refers to is no longer available.',
    },
    'share.invite-generic-error': {
        id: 'share.invite-generic-error',
        defaultMessage: "We couldn't load that invitation. Please try again.",
    },
    'share.invite.generic.error': {
        id: 'share.invite.generic.error',
        defaultMessage: 'Something went wrong. Please try again.',
    },
    'verify.email.pending': {
        id: 'verify.email.pending',
        defaultMessage: 'Verifying…',
    },
    'verify.email.success': {
        id: 'verify.email.success',
        defaultMessage: '{email} is now verified on your account.',
    },
    'verify.email.continue': {
        id: 'verify.email.continue',
        defaultMessage: 'Continue to your workspace',
    },
    'verify.email.back': {
        id: 'verify.email.back',
        defaultMessage: 'Back to workspace',
    },
    'verify.email.error.generic': {
        id: 'verify.email.error.generic',
        defaultMessage: "That verification link isn't valid or has expired.",
    },
    'error.organisation.invite.not.found': {
        id: 'error.organisation.invite.not.found',
        defaultMessage: 'That organization invitation no longer exists.',
    },
    'error.organisation.invite.not.your.own': {
        id: 'error.organisation.invite.not.your.own',
        defaultMessage:
            'That invitation was sent to a different email address. Add it as a verified email on your account and try again.',
    },
    'error.organisation.invite.unauthorised': {
        id: 'error.organisation.invite.unauthorised',
        defaultMessage:
            'You need to be signed in to accept an organization invitation.',
    },
    'error.reminder.not.found': {
        id: 'error.reminder.not.found',
        defaultMessage: 'That reminder no longer exists.',
    },
    'error.reminder.not.your.own': {
        id: 'error.reminder.not.your.own',
        defaultMessage: 'You can only modify your own reminders.',
    },
    'error.verified.email.token.invalid': {
        id: 'error.verified.email.token.invalid',
        defaultMessage: "That verification link isn't valid or has expired.",
    },
    'error.verified.email.token.mismatch': {
        id: 'error.verified.email.token.mismatch',
        defaultMessage:
            'This link belongs to a different account. Log in with the correct account and try again.',
    },
    'error.verified.email.invalid': {
        id: 'error.verified.email.invalid',
        defaultMessage: "That email address isn't valid.",
    },
    'error.verified.email.is.primary': {
        id: 'error.verified.email.is.primary',
        defaultMessage: "That's already your primary email.",
    },
    'error.verified.email.already.on.account': {
        id: 'error.verified.email.already.on.account',
        defaultMessage: 'That email is already verified on your account.',
    },
    'error.verified.email.in.use': {
        id: 'error.verified.email.in.use',
        defaultMessage: 'That email is already used by another tidee account.',
    },
    'error.verified.email.cannot.remove.primary': {
        id: 'error.verified.email.cannot.remove.primary',
        defaultMessage: "You can't remove your primary email from here.",
    },
    'error.cross.org.move.blocked': {
        id: 'error.cross.org.move.blocked',
        defaultMessage:
            "You can't move items across organizations. Duplicate the item into the other space instead.",
    },
    'error.cannot.move.item.into.itself': {
        id: 'error.cannot.move.item.into.itself',
        defaultMessage: "You can't move a box into itself.",
    },
    'error.cannot.move.item.into.own.descendant': {
        id: 'error.cannot.move.item.into.own.descendant',
        defaultMessage:
            "You can't move a box into one of the boxes it contains. Choose a destination outside it.",
    },
    'workspace.org.toggle.hide': {
        id: 'workspace.org.toggle.hide',
        defaultMessage: 'Hide items from {name}',
    },
    'workspace.org.toggle.show': {
        id: 'workspace.org.toggle.show',
        defaultMessage: 'Show items from {name}',
    },
    'sidebar.spaces.label': {
        id: 'sidebar.spaces.label',
        defaultMessage: 'Spaces',
    },
    'settings.modal.space': {
        id: 'settings.modal.space',
        defaultMessage: 'Space',
    },
    'capture.modal.field.active.org': {
        id: 'capture.modal.field.active.org',
        defaultMessage: 'Space',
    },
    'capture.modal.field.active.org.hint': {
        id: 'capture.modal.field.active.org.hint',
        defaultMessage:
            'The space this item will live in. Items inside a box inherit the box’s space instead.',
    },
    'settings.modal.share.org.section.label': {
        id: 'settings.modal.share.org.section.label',
        defaultMessage: 'Share with everyone in an organization',
    },
    'settings.modal.share.email.placeholder': {
        id: 'settings.modal.share.email.placeholder',
        defaultMessage: 'alice@example.com, bob@example.com',
    },
    'settings.modal.share.email.hint': {
        id: 'settings.modal.share.email.hint',
        defaultMessage:
            'Separate multiple email addresses with commas or semicolons.',
    },
    'settings.modal.share.email.invalid': {
        id: 'settings.modal.share.email.invalid',
        defaultMessage: "These addresses aren't valid: {addresses}",
    },
    'settings.modal.share.added.success.multi': {
        id: 'settings.modal.share.added.success.multi',
        defaultMessage: 'Shared with {count} recipients.',
    },
    'organisations.modal.selected.organisation.colour': {
        id: 'organisations.modal.selected.organisation.colour',
        defaultMessage: 'Color',
    },
    'organisations.modal.selected.organisation.colour.intro': {
        id: 'organisations.modal.selected.organisation.colour.intro',
        defaultMessage:
            'This color appears on the workspace toggle chip and the left-edge strip of every item that lives in this organization.',
    },
    'organisations.modal.ownership.no.capabilities': {
        id: 'organisations.modal.ownership.no.capabilities',
        defaultMessage:
            'Members hold a seat in the organization. Sharing is per-recipient — no additional org-level capabilities apply.',
    },
});
export default messages;
